import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api/axios";
import homeapi from "../api/homeapi";
/* ═══════════════════════════════════════════════════════════
   ICONS
═══════════════════════════════════════════════════════════ */
const Ico = {
  Ticket:  () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="4" width="14" height="8" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M5 8h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Route:   () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="3" cy="4" r="2" stroke="currentColor" strokeWidth="1.5"/><circle cx="13" cy="12" r="2" stroke="currentColor" strokeWidth="1.5"/><path d="M3 6v2a4 4 0 004 4h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  User:    () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="5" r="3" stroke="currentColor" strokeWidth="1.5"/><path d="M2 13c0-2.8 2.7-5 6-5s6 2.2 6 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Card:    () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M1 7h14" stroke="currentColor" strokeWidth="1.5"/><path d="M4 10h2M9 10h3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Logout:  () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M6 2H3a1 1 0 00-1 1v10a1 1 0 001 1h3M10 11l3-3-3-3M13 8H6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Search:  () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="6.5" cy="6.5" r="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M10 10L14 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Bars:    () => <svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M2 4h14M2 9h14M2 14h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Grid:    () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="1" width="6" height="6" rx="1.5" fill="currentColor"/><rect x="9" y="1" width="6" height="6" rx="1.5" fill="currentColor" opacity=".4"/><rect x="1" y="9" width="6" height="6" rx="1.5" fill="currentColor" opacity=".4"/><rect x="9" y="9" width="6" height="6" rx="1.5" fill="currentColor" opacity=".4"/></svg>,
  Car:     () => <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><rect x="1" y="6" width="14" height="7" rx="2" stroke="currentColor" strokeWidth="1.5"/><circle cx="4.5" cy="13.5" r="1.5" fill="currentColor"/><circle cx="11.5" cy="13.5" r="1.5" fill="currentColor"/><path d="M1 9l2-5h10l2 5" stroke="currentColor" strokeWidth="1.5"/></svg>,
  Arrow:   () => <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2 6h8M7 3l3 3-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Pin:     () => <svg width="11" height="11" viewBox="0 0 16 16" fill="none"><path d="M8 1C5.8 1 4 2.8 4 5c0 3 4 9 4 9s4-6 4-9c0-2.2-1.8-4-4-4z" stroke="currentColor" strokeWidth="1.5"/><circle cx="8" cy="5" r="1.5" stroke="currentColor" strokeWidth="1.5"/></svg>,
  Star:    () => <svg width="11" height="11" viewBox="0 0 16 16" fill="currentColor"><path d="M8 1L10 6H15L11 9.5L12.5 15L8 12L3.5 15L5 9.5L1 6H6L8 1Z"/></svg>,
  Clock:   () => <svg width="11" height="11" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/><path d="M8 4v4l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Users:   () => <svg width="11" height="11" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M1 13c0-2.5 2.2-4.5 5-4.5s5 2 5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="12" cy="5" r="2" stroke="currentColor" strokeWidth="1.3"/><path d="M14 13c0-2-1.3-3.6-3-4.2" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"/></svg>,
  Chev:    () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M5 3l3 3-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  X:       () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Plus:    () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M8 2v12M2 8h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Trash:   () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M2 4h12M5 4V3a1 1 0 011-1h4a1 1 0 011 1v1M6 7v5M10 7v5M3 4l1 9a1 1 0 001 1h6a1 1 0 001-1l1-9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Check:   () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 8l4 4 6-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Down:    () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M8 2v9M5 8l3 3 3-3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M2 13h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Edit:    () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M11 2l3 3L5 14H2v-3L11 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>,
  Phone:   () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 2h3l1.5 3.5-1.5 1a8 8 0 004.5 4.5l1-1.5L15 11v3a1 1 0 01-1 1A12 12 0 012 3a1 1 0 011-1z" stroke="currentColor" strokeWidth="1.3"/></svg>,
  Mail:    () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M1 6l7 4 7-4" stroke="currentColor" strokeWidth="1.5"/></svg>,
  Key:     () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="6" cy="7" r="4" stroke="currentColor" strokeWidth="1.5"/><path d="M9.5 9.5L14 14M12 12l1.5-1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  Info:    () => <svg width="13" height="13" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/><path d="M8 7v5M8 5v.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
};

/* ═══════════════════════════════════════════════════════════
   CONSTANTS
═══════════════════════════════════════════════════════════ */
const OPERATORS = ["MVola", "Orange Money", "Airtel Money"];

const OPERATOR_NUMBERS = {
  "MVola":        "034 570 0524",
  "Orange Money": "037 313 3441",
  "Airtel Money": "033 579 2739",
};

const BASE = homeapi.defaults.baseURL?.replace(/\/$/, "");

/* Spinners */
const SpinGreen = () => (
  <span style={{ display:"inline-block", width:13, height:13, border:"2px solid rgba(22,163,74,0.2)", borderTopColor:"#16a34a", borderRadius:"50%", animation:"spin 0.6s linear infinite", marginRight:6, verticalAlign:"middle" }} />
);
const SpinWhite = () => (
  <span style={{ display:"inline-block", width:13, height:13, border:"2px solid rgba(255,255,255,0.3)", borderTopColor:"white", borderRadius:"50%", animation:"spin 0.6s linear infinite", marginRight:6, verticalAlign:"middle" }} />
);

/* ═══════════════════════════════════════════════════════════
   VEHICLE PHOTOS GALLERY
═══════════════════════════════════════════════════════════ */
const VehiclePhotos = ({ photos }) => {
  const [activeIdx, setActiveIdx] = React.useState(0);
  if (!photos || photos.length === 0) return null;

  const resolveUrl = (p) => {
    if (!p) return null;
    if (p.startsWith("http")) return p;
    const base = (BASE || "").replace(/\/api$/, "");
    return `${base}/${p}`.replace(/([^:])\/\//g, "$1/");
  };

  const sorted = [...photos].sort((a, b) => {
    const aInt = /int[eé]r/i.test(a) ? 1 : 0;
    const bInt = /int[eé]r/i.test(b) ? 1 : 0;
    return aInt - bInt;
  });

  return (
    <div style={{ marginBottom:12 }}>
      <div style={{ position:"relative", borderRadius:10, overflow:"hidden", height:180, background:"#f1f5f9" }}>
        <img
          src={resolveUrl(sorted[activeIdx])}
          alt=""
          style={{ width:"100%", height:"100%", objectFit:"cover", display:"block" }}
          onError={e => { e.target.style.display="none"; }}
        />
        {sorted.length > 1 && (
          <>
            <button onClick={()=>setActiveIdx(i=>(i-1+sorted.length)%sorted.length)}
              style={{ position:"absolute",left:6,top:"50%",transform:"translateY(-50%)",background:"rgba(0,0,0,0.4)",border:"none",borderRadius:6,color:"white",width:28,height:28,cursor:"pointer",fontSize:15,display:"flex",alignItems:"center",justifyContent:"center" }}>‹</button>
            <button onClick={()=>setActiveIdx(i=>(i+1)%sorted.length)}
              style={{ position:"absolute",right:6,top:"50%",transform:"translateY(-50%)",background:"rgba(0,0,0,0.4)",border:"none",borderRadius:6,color:"white",width:28,height:28,cursor:"pointer",fontSize:15,display:"flex",alignItems:"center",justifyContent:"center" }}>›</button>
          </>
        )}
        <div style={{ position:"absolute",top:8,left:8,fontSize:10,color:"white",background:/int[eé]r/i.test(sorted[activeIdx])?"rgba(22,163,74,0.85)":"rgba(15,23,42,0.7)",borderRadius:4,padding:"2px 7px",fontWeight:600 }}>
          {/int[eé]r/i.test(sorted[activeIdx])?"Intérieur":"Extérieur"}
        </div>
        <div style={{ position:"absolute",bottom:6,right:8,fontSize:9,color:"white",background:"rgba(0,0,0,0.35)",borderRadius:4,padding:"2px 6px" }}>
          {activeIdx+1}/{sorted.length}
        </div>
      </div>
      {sorted.length > 1 && (
        <div style={{ display:"flex",gap:5,marginTop:5,overflowX:"auto" }}>
          {sorted.map((p,i) => (
            <div key={i} onClick={()=>setActiveIdx(i)}
              style={{ flexShrink:0,width:50,height:36,borderRadius:6,overflow:"hidden",cursor:"pointer",border:i===activeIdx?"2px solid #1d4ed8":"2px solid transparent",opacity:i===activeIdx?1:0.6,transition:"all .15s" }}>
              <img src={resolveUrl(p)} alt="" style={{ width:"100%",height:"100%",objectFit:"cover" }} onError={e=>{e.target.style.display="none";}} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   ATOMS
═══════════════════════════════════════════════════════════ */
const StatusBadge = ({ status }) => {
  const map = {
    CONFIRMED: { bg:"#f0fdf4", color:"#16a34a", border:"#bbf7d0", label:"Confirmé"   },
    SUCCESS:   { bg:"#f0fdf4", color:"#16a34a", border:"#bbf7d0", label:"Payé"        },
    PENDING:   { bg:"#fffbeb", color:"#d97706", border:"#fde68a", label:"En attente"  },
    CANCELLED: { bg:"#fff5f5", color:"#dc2626", border:"#fecaca", label:"Annulé"      },
  };
  const m = map[(status || "PENDING").toUpperCase()] || map.PENDING;
  return (
    <span style={{ fontSize:11, padding:"3px 10px", borderRadius:20, fontWeight:600, background:m.bg, color:m.color, border:`0.5px solid ${m.border}` }}>
      {m.label}
    </span>
  );
};

const Toast = ({ t }) => t ? (
  <div style={{ position:"fixed", bottom:24, right:24, background:"white", border:`0.5px solid ${t.type==="success"?"#bbf7d0":"#fecaca"}`, padding:"12px 18px", borderRadius:12, fontSize:13, color:"#0f172a", zIndex:9999, display:"flex", alignItems:"center", gap:8, boxShadow:"0 8px 24px rgba(0,0,0,0.1)", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
    <span style={{ width:7, height:7, borderRadius:"50%", background:t.type==="success"?"#16a34a":"#dc2626", flexShrink:0 }} />{t.msg}
  </div>
) : null;

const Field = ({ label, children, hint }) => (
  <div style={{ marginBottom:14 }}>
    <label style={{ display:"block", fontSize:10.5, fontWeight:700, color:"#64748b", textTransform:"uppercase", letterSpacing:0.5, marginBottom:5 }}>{label}</label>
    {children}
    {hint && <div style={{ fontSize:11, color:"#94a3b8", marginTop:4 }}>{hint}</div>}
  </div>
);

const inp = { width:"100%", padding:"9px 12px", background:"#f8fafc", border:"0.5px solid #e2e8f0", borderRadius:9, fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", color:"#0f172a", outline:"none", boxSizing:"border-box" };
const sel = { ...inp, cursor:"pointer" };

const Card = ({ children, style }) => (
  <div style={{ background:"white", border:"0.5px solid #e2e8f0", borderRadius:12, padding:"20px 22px", marginBottom:16, ...style }}>
    {children}
  </div>
);

const CardHead = ({ title, badge, action }) => (
  <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16, flexWrap:"wrap", gap:8 }}>
    <div style={{ fontSize:14, fontWeight:700, color:"#0f172a", letterSpacing:-0.2 }}>{title}</div>
    <div style={{ display:"flex", alignItems:"center", gap:8 }}>{badge}{action}</div>
  </div>
);

const GreenBadge = ({ n, label }) => (
  <span style={{ fontSize:11, padding:"3px 10px", borderRadius:20, background:"#f0fdf4", color:"#16a34a", fontWeight:600, border:"0.5px solid #bbf7d0" }}>{n} {label}</span>
);
const GrayBadge  = ({ children }) => (
  <span style={{ fontSize:11, padding:"3px 10px", borderRadius:20, background:"#f1f5f9", color:"#64748b", fontWeight:600, border:"0.5px solid #e2e8f0" }}>{children}</span>
);
const Pill = ({ children }) => (
  <span style={{ fontSize:12, background:"#f1f5f9", padding:"3px 8px", borderRadius:6, color:"#475569", fontWeight:500 }}>{children}</span>
);
const MetaChip = ({ children, yellow }) => (
  <span style={{ display:"flex", alignItems:"center", gap:5, fontSize:11, color:yellow?"#d97706":"#64748b", background:yellow?"#fffbeb":"#f8fafc", padding:"4px 10px", borderRadius:20, border:`0.5px solid ${yellow?"#fde68a":"#e2e8f0"}` }}>
    {children}
  </span>
);

const TypeBadge = ({ type }) => {
  const isTB = type === "taxi-brousse";
  return (
    <span style={{ fontSize:10, padding:"2px 8px", borderRadius:20, background:isTB?"#eff6ff":"#f0fdf4", color:isTB?"#1d4ed8":"#16a34a", border:`0.5px solid ${isTB?"#bfdbfe":"#bbf7d0"}`, fontWeight:600 }}>
      {isTB ? "Taxi-brousse" : "Covoiturage"}
    </span>
  );
};

/* Table primitives */
const Th = ({ children }) => (
  <th style={{ textAlign:"left", padding:"8px 12px", color:"#94a3b8", fontSize:10, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.5px", borderBottom:"0.5px solid #f1f5f9", background:"#fafafa" }}>
    {children}
  </th>
);
const Td = ({ children, style }) => (
  <td style={{ padding:"11px 12px", borderBottom:"0.5px solid #f8fafc", color:"#334155", verticalAlign:"middle", ...style }}>
    {children}
  </td>
);

/* ═══════════════════════════════════════════════════════════
   OPERATOR PAYMENT BOX
═══════════════════════════════════════════════════════════ */
const OperatorPayBox = ({ operator, amount, bookingRef }) => {
  if (!operator || !OPERATOR_NUMBERS[operator]) return null;
  return (
    <div style={{ background:"#0f172a", borderRadius:10, padding:"14px 16px", margin:"10px 0 14px" }}>
      <div style={{ fontSize:10, color:"rgba(255,255,255,0.45)", textTransform:"uppercase", letterSpacing:0.5, marginBottom:4 }}>
        Envoyez {amount ? `${Number(amount).toLocaleString()} MGA` : "le montant"} au numéro suivant
      </div>
      <div style={{ fontFamily:"'DM Mono',monospace", fontSize:20, color:"white", letterSpacing:2, fontWeight:500, marginBottom:4 }}>
        {OPERATOR_NUMBERS[operator]}
      </div>
      <div style={{ fontSize:10, color:"rgba(255,255,255,0.35)" }}>
        {operator} · {bookingRef ? `Réf : ${bookingRef}` : "Indiquez votre référence en commentaire"}
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   TICKET HTML BUILDER — génère UN ou PLUSIEURS billets
═══════════════════════════════════════════════════════════ */
const buildTicketHTML = ({ seats, trip, fullName, bookings, operator, phone, txRef, totalPrice, passengers }) => {
  const depName  = trip.departure?.name  || trip.departure  || trip.dep  || "—";
  const arrName  = trip.arrival?.name    || trip.arrival    || trip.dest || "—";
  const transporter = trip.transporter?.name || trip.transporter || "—";
  const transporterPhone = trip.transporter?.phone || "";
  const tripDate = trip.date || "";
  const tripTime = trip.departureTime || trip.time || "";
  const pricePerSeat = Number(trip.price || 0);
  const issuedAt = new Date().toLocaleString("fr-FR", { dateStyle:"short", timeStyle:"short" });
  const tripType = trip.type === "covoiturage" ? "Covoiturage" : "Taxi-brousse";

  // bookings est un tableau : [{ bookingId, reference, seatNumber }, ...]
  // seats est un tableau de numéros de siège : [1, 3, 5]
  // On associe chaque siège à sa réservation dans l'ordre
  const ticketBlock = (seatNum, idx) => {
    const booking = bookings[idx] || bookings[0] || {};
    const reference = booking.reference || "—";
    return `
    <div class="ticket" style="page-break-after: ${idx < seats.length - 1 ? 'always' : 'auto'};">
      <div class="header">
        <div class="logo">Trans<span>TiGo</span></div>
        <div class="route">${depName} → ${arrName}</div>
        <div class="route-sub">
          <span>${tripDate}${tripTime ? " · " + tripTime : ""}</span>
          <span class="type-badge">${tripType}</span>
          ${seats.length > 1 ? `<span class="ticket-counter">Billet ${idx + 1}/${seats.length}</span>` : ""}
        </div>
      </div>
      <div class="body">
        <div class="status-bar">
          <div class="status-left">✓ Billet confirmé &amp; payé</div>
          <div class="status-right">Émis le ${issuedAt}</div>
        </div>
        <div class="info-grid">
          <div class="info-item"><div class="info-label">Passager</div><div class="info-value">${fullName}</div></div>
          <div class="info-item"><div class="info-label">Transporteur</div><div class="info-value">${transporter}</div></div>
          <div class="info-item"><div class="info-label">Départ</div><div class="info-value">${depName}</div></div>
          <div class="info-item"><div class="info-label">Arrivée</div><div class="info-value">${arrName}</div></div>
          <div class="info-item"><div class="info-label">Date</div><div class="info-value">${tripDate || "—"}</div></div>
          <div class="info-item"><div class="info-label">Heure de départ</div><div class="info-value">${tripTime || "—"}</div></div>
          ${transporterPhone ? `<div class="info-item"><div class="info-label">Tél. transporteur</div><div class="info-value green">${transporterPhone}</div></div>` : ""}
          <div class="info-item"><div class="info-label">Nb. passagers</div><div class="info-value">${passengers}</div></div>
        </div>
        <hr class="divider"/>
        <div class="seat-block">
          <div class="seat-num">${String(seatNum).padStart(2,"0")}</div>
          <div class="seat-label">Numéro de siège</div>
        </div>
        <div class="payment-block">
          <div class="payment-title">Détails du paiement</div>
          <div class="payment-grid">
            <div class="info-item"><div class="info-label">Opérateur</div><div class="info-value">${operator || "—"}</div></div>
            <div class="info-item"><div class="info-label">Téléphone</div><div class="info-value mono">${phone || "—"}</div></div>
            <div class="info-item"><div class="info-label">Prix / place</div><div class="info-value green">${pricePerSeat.toLocaleString("fr-FR")} MGA</div></div>
            <div class="info-item"><div class="info-label">Montant total</div><div class="info-value green">${Number(totalPrice).toLocaleString("fr-FR")} MGA</div></div>
            <div class="info-item" style="grid-column:1/-1"><div class="info-label">Réf. transaction</div><div class="info-value mono">${txRef || "—"}</div></div>
          </div>
        </div>
        <hr class="divider"/>
        <div class="ref-block">
          <div class="ref-label">Référence de réservation</div>
          <div class="ref-value">${reference}</div>
          <div class="ref-hint">Présentez ce document au chauffeur lors de l'embarquement</div>
        </div>
        <div class="footer">
          Ce billet est valable uniquement pour le trajet indiqué.<br/>
          En cas de problème, contactez le transporteur au ${transporterPhone || "numéro fourni"}.<br/>
          <strong>TransTiGo · Madagascar</strong>
        </div>
      </div>
    </div>
  `};

  const seatList = Array.isArray(seats) ? [...seats].sort((a,b)=>a-b) : [seats];

  return `<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8"/>
  <title>Billets — Sièges ${seatList.map(s=>String(s).padStart(2,"0")).join(", ")}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&family=DM+Mono:wght@400;500&display=swap');
    *{margin:0;padding:0;box-sizing:border-box}
    body{font-family:'Plus Jakarta Sans',sans-serif;background:#f0f2f5;display:flex;flex-direction:column;align-items:center;padding:40px 20px;min-height:100vh;gap:32px}
    .ticket{background:white;width:440px;border-radius:20px;overflow:hidden;box-shadow:0 12px 48px rgba(0,0,0,.14)}
    .header{background:#0f172a;padding:28px 30px 24px;color:white;position:relative;overflow:hidden}
    .header::before{content:'';position:absolute;right:-30px;top:-30px;width:180px;height:180px;border-radius:50%;background:rgba(22,163,74,0.1)}
    .header::after{content:'';position:absolute;right:50px;bottom:-50px;width:120px;height:120px;border-radius:50%;background:rgba(22,163,74,0.06)}
    .logo{font-size:15px;font-weight:800;margin-bottom:18px;letter-spacing:-0.3px}
    .logo span{color:#16a34a}
    .route{font-size:22px;font-weight:800;letter-spacing:-0.5px;margin-bottom:6px}
    .route-sub{color:rgba(255,255,255,0.45);font-size:12px;display:flex;align-items:center;gap:10px;flex-wrap:wrap}
    .type-badge{display:inline-block;padding:2px 10px;border-radius:20px;font-size:10px;font-weight:700;background:rgba(22,163,74,0.2);color:#4ade80;border:1px solid rgba(22,163,74,0.3)}
    .ticket-counter{display:inline-block;padding:2px 10px;border-radius:20px;font-size:10px;font-weight:700;background:rgba(255,255,255,0.1);color:rgba(255,255,255,0.6);border:1px solid rgba(255,255,255,0.15)}
    .body{padding:26px 30px}
    .status-bar{display:flex;align-items:center;justify-content:space-between;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:10px;padding:11px 16px;margin-bottom:22px}
    .status-left{font-size:12px;color:#16a34a;font-weight:700}
    .status-right{font-size:11px;color:#64748b}
    .info-grid{display:grid;grid-template-columns:1fr 1fr;gap:16px;margin-bottom:20px}
    .info-label{font-size:9.5px;color:#94a3b8;text-transform:uppercase;letter-spacing:.7px;font-weight:700;margin-bottom:4px}
    .info-value{font-size:13.5px;font-weight:700;color:#0f172a;line-height:1.3}
    .info-value.mono{font-family:'DM Mono',monospace;letter-spacing:.5px}
    .info-value.green{color:#16a34a}
    .divider{position:relative;margin:20px -30px;border:none;border-top:2px dashed #e2e8f0}
    .divider::before{content:'';position:absolute;left:-10px;top:50%;transform:translateY(-50%);width:20px;height:20px;border-radius:50%;background:#f0f2f5}
    .divider::after{content:'';position:absolute;right:-10px;top:50%;transform:translateY(-50%);width:20px;height:20px;border-radius:50%;background:#f0f2f5}
    .seat-block{text-align:center;background:linear-gradient(135deg,#f0fdf4,#dcfce7);border:1.5px solid #bbf7d0;border-radius:14px;padding:18px 14px;margin-bottom:20px}
    .seat-num{font-family:'DM Mono',monospace;font-size:52px;font-weight:500;color:#16a34a;line-height:1;margin-bottom:4px}
    .seat-label{font-size:11px;color:#16a34a;font-weight:700;text-transform:uppercase;letter-spacing:.6px}
    .payment-block{background:#f8fafc;border:0.5px solid #e2e8f0;border-radius:10px;padding:14px 16px;margin-bottom:20px}
    .payment-title{font-size:10px;color:#94a3b8;text-transform:uppercase;letter-spacing:.6px;font-weight:700;margin-bottom:10px}
    .payment-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px}
    .ref-block{background:#0f172a;border-radius:10px;padding:14px 16px;margin-bottom:20px}
    .ref-label{font-size:9.5px;color:rgba(255,255,255,0.4);text-transform:uppercase;letter-spacing:.7px;margin-bottom:6px}
    .ref-value{font-family:'DM Mono',monospace;font-size:20px;color:white;letter-spacing:2.5px;font-weight:500}
    .ref-hint{font-size:10px;color:rgba(255,255,255,0.3);margin-top:4px}
    .footer{font-size:11px;color:#b0b8c4;text-align:center;line-height:1.7;padding-top:4px;border-top:0.5px solid #f1f5f9;margin-top:6px}
    @media print{
      body{padding:0;background:white;gap:0}
      .ticket{box-shadow:none;border-radius:0;width:100%}
    }
  </style>
</head>
<body>
  ${seatList.map((s, i) => ticketBlock(s, i)).join("\n")}
  <script>setTimeout(()=>window.print(),500)</script>
</body>
</html>`;
};

/* ═══════════════════════════════════════════════════════════
   SEAT PICKER — affiche sièges libres/pris/sélectionnés
═══════════════════════════════════════════════════════════ */
const SeatPicker = ({ totalSeats, takenSeats, selectedSeats, onToggle, maxSelectable }) => {
  return (
    <div>
      {/* Légende */}
      <div style={{ display:"flex", gap:12, marginBottom:10, flexWrap:"wrap" }}>
        {[
          { color:"#f8fafc", border:"1.5px solid #e2e8f0", textColor:"#64748b", label:"Libre" },
          { color:"#fef2f2", border:"1.5px solid #fca5a5", textColor:"#dc2626", label:"Pris" },
          { color:"#f0fdf4", border:"2px solid #16a34a",   textColor:"#16a34a", label:"Sélectionné" },
        ].map(({ color, border, textColor, label }) => (
          <div key={label} style={{ display:"flex", alignItems:"center", gap:5 }}>
            <div style={{ width:14, height:14, borderRadius:4, background:color, border }} />
            <span style={{ fontSize:10.5, color:"#64748b" }}>{label}</span>
          </div>
        ))}
      </div>

      {/* Grille des sièges */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(6,1fr)", gap:5, marginBottom:8 }}>
        {Array.from({ length: totalSeats }, (_, i) => i + 1).map(n => {
          const isTaken    = takenSeats.includes(n);
          const isSelected = selectedSeats.includes(n);

          let bg     = "#f8fafc";
          let border = "1.5px solid #e2e8f0";
          let color  = "#64748b";
          let cursor = "pointer";
          let title  = `Siège ${n}`;

          if (isTaken) {
            bg     = "#fef2f2";
            border = "1.5px solid #fca5a5";
            color  = "#dc2626";
            cursor = "not-allowed";
            title  = `Siège ${n} — Déjà réservé`;
          } else if (isSelected) {
            bg     = "#f0fdf4";
            border = "2px solid #16a34a";
            color  = "#16a34a";
          }

          return (
            <button
              key={n}
              title={title}
              disabled={isTaken}
              onClick={() => !isTaken && onToggle(n)}
              style={{
                padding:"7px 4px", borderRadius:7, fontSize:11.5, fontWeight:600,
                cursor, fontFamily:"inherit", border, background:bg, color,
                transition:"all .12s", position:"relative",
                opacity: isTaken ? 0.7 : 1,
              }}
            >
              {n}
              {isTaken && (
                <span style={{
                  position:"absolute", top:1, right:2,
                  fontSize:7, color:"#dc2626", fontWeight:800,
                }}>✕</span>
              )}
            </button>
          );
        })}
      </div>

      {/* Recap sièges pris */}
      {takenSeats.length > 0 && (
        <div style={{ fontSize:11, color:"#94a3b8", marginBottom:4, display:"flex", alignItems:"center", gap:4 }}>
          <Ico.Info />
          <span>Sièges déjà pris : <strong style={{ color:"#dc2626" }}>{[...takenSeats].sort((a,b)=>a-b).join(", ")}</strong></span>
        </div>
      )}

      {selectedSeats.length > 0 && (
        <div style={{ fontSize:11, color:"#16a34a", fontWeight:600 }}>
          Sièges sélectionnés : {[...selectedSeats].sort((a,b)=>a-b).join(", ")} ({selectedSeats.length}/{maxSelectable})
        </div>
      )}
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   BOOKING MODAL
═══════════════════════════════════════════════════════════ */
const BookingModal = ({ trip, onClose, onSuccess }) => {
  const [step,        setStep]     = useState(1);
  const [fullName,    setName]     = useState("");
  const [seatNums,    setSeats]    = useState([]);       // sièges sélectionnés par l'utilisateur
  const [passengers,  setPassengers] = useState(1);
  const [operator,    setOp]       = useState("");
  const [phone,       setPhone]    = useState("");
  const [txRef,       setTxRef]    = useState("");
  const [bookings,    setBookings] = useState([]);       // [{ bookingId, reference, seatNumber }]
  const [groupRef,    setGroupRef] = useState("");       // ref du groupe (ex. MV-XXXXXX)
  const [loading,     setLoading]  = useState(false);
  const [error,       setError]    = useState("");

  // takenSeats vient directement de l'API search
  const takenSeats = trip.takenSeats || [];
  const totalSeats = trip.totalSeats || trip.seats || 30;

  const toggleSeat = (n) => {
    setSeats(prev =>
      prev.includes(n)
        ? prev.filter(s => s !== n)
        : prev.length < passengers ? [...prev, n] : [...prev.slice(1), n]
    );
  };

  // STEP 1 → STEP 2 : crée N réservations (une par siège)
  const book = async () => {
    if (!fullName.trim())      { setError("Le nom complet est requis."); return; }
    if (seatNums.length === 0) { setError("Sélectionnez au moins un siège."); return; }
    if (seatNums.length < passengers) {
      setError(`Sélectionnez exactement ${passengers} siège${passengers > 1 ? "s" : ""}.`);
      return;
    }

    // Vérification côté client : aucun siège déjà pris ne doit être dans la sélection
    const conflict = seatNums.filter(s => takenSeats.includes(s));
    if (conflict.length > 0) {
      setError(`Le(s) siège(s) ${conflict.join(", ")} sont déjà pris.`);
      return;
    }

    setLoading(true); setError("");
    try {
      const r = await api.post("/dashboard/bookings", {
        tripId:      trip.id,
        seatNumbers: seatNums,          // tableau de tous les sièges sélectionnés
        seatNumber:  seatNums[0],       // rétrocompatibilité
        fullName,
        quantity:    passengers,
      });
      // Le backend retourne : { bookingIds, bookings, groupRef, reference }
      // bookings = [{ bookingId, reference, seatNumber }, ...]
      setBookings(r.data.bookings || [{ bookingId: r.data.bookingId, reference: r.data.reference, seatNumber: seatNums[0] }]);
      setGroupRef(r.data.groupRef || r.data.reference || "");
      setStep(2);
    } catch(e) {
      setError(e?.response?.data?.error || e?.response?.data?.message || "Erreur lors de la réservation.");
    }
    setLoading(false);
  };

  // STEP 2 → STEP 3 : vérifie le paiement pour tous les bookings du groupe
  const pay = async () => {
    if (!operator || !phone || !txRef) { setError("Remplissez tous les champs."); return; }
    setLoading(true); setError("");
    try {
      // On envoie tous les bookingIds pour confirmer le groupe en une seule requête
      const bookingIds = bookings.map(b => b.bookingId);
      await api.post("/dashboard/verify-payment", {
        bookingIds,                       // tableau de tous les IDs
        bookingId: bookingIds[0],         // rétrocompatibilité (1er ID)
        transactionReference: txRef,
        operator,
        phoneNumber: phone,
      });
      setStep(3);
    } catch(e) {
      setError(e?.response?.data?.error || "Référence de transaction invalide.");
    }
    setLoading(false);
  };

  // Génère et ouvre la fenêtre d'impression avec tous les billets
  const downloadTickets = () => {
    const totalPrice = Number(trip.price) * passengers;
    const sortedSeats = [...seatNums].sort((a, b) => a - b);
    const w = window.open("", "_blank");
    if (w) {
      w.document.write(buildTicketHTML({
        seats:      sortedSeats,
        trip,
        fullName,
        bookings,                 // tableau complet pour associer ref ↔ siège
        operator,
        phone,
        txRef,
        totalPrice,
        passengers,
      }));
      w.document.close();
    }
  };

  const depName    = trip.departure?.name || trip.departure || trip.dep || "";
  const arrName    = trip.arrival?.name   || trip.arrival   || trip.dest || "";
  const totalPrice = Number(trip.price) * passengers;

  return (
    <div
      style={{ position:"fixed", inset:0, background:"rgba(15,23,42,0.55)", backdropFilter:"blur(4px)", zIndex:600, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}
      onClick={e => e.target === e.currentTarget && onClose()}
    >
      <div style={{ background:"white", borderRadius:16, width:"100%", maxWidth:480, maxHeight:"92vh", overflowY:"auto", boxShadow:"0 24px 80px rgba(0,0,0,0.15)" }}>
        {/* Header */}
        <div style={{ padding:"20px 24px 14px", borderBottom:"0.5px solid #f1f5f9", display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
          <div>
            <div style={{ fontSize:16, fontWeight:800, color:"#0f172a", letterSpacing:-0.3 }}>
              {step===1 ? "Réserver votre place" : step===2 ? "Paiement Mobile Money" : "Réservation confirmée ✓"}
            </div>
            <div style={{ fontSize:12, color:"#94a3b8", marginTop:3 }}>
              {depName} → {arrName} · {trip.departureTime || trip.time || ""}
            </div>
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8", padding:4 }}>
            <Ico.X />
          </button>
        </div>

        {/* Progress */}
        <div style={{ display:"flex", padding:"10px 24px", gap:6 }}>
          {["Infos","Paiement","Billet"].map((l,i) => (
            <div key={l} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
              <div style={{ width:"100%", height:3, borderRadius:4, background:step>i?"#16a34a":"#f1f5f9", transition:"background .3s" }} />
              <div style={{ fontSize:10, color:step>i?"#16a34a":"#94a3b8", fontWeight:600 }}>{l}</div>
            </div>
          ))}
        </div>

        <div style={{ padding:"8px 24px 24px" }}>

          {/* ─── STEP 1 ─── */}
          {step===1 && <>
            <Field label="Nom complet *">
              <input style={inp} placeholder="Ex : Rakoto Jean" value={fullName} onChange={e=>setName(e.target.value)} />
            </Field>

            <Field label="Nombre de passagers *">
              <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
                <button
                  onClick={() => { const n=Math.max(1,passengers-1); setPassengers(n); setSeats(s=>s.slice(0,n)); }}
                  style={{ width:30,height:30,borderRadius:8,border:"1.5px solid #e2e8f0",background:"#f8fafc",cursor:"pointer",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700 }}
                >−</button>
                <span style={{ fontSize:15,fontWeight:700,color:"#0f172a",minWidth:24,textAlign:"center" }}>{passengers}</span>
                <button
                  onClick={() => setPassengers(p=>Math.min(totalSeats - takenSeats.length, p+1))}
                  style={{ width:30,height:30,borderRadius:8,border:"1.5px solid #e2e8f0",background:"#f8fafc",cursor:"pointer",fontSize:16,display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700 }}
                >+</button>
                <span style={{ fontSize:11,color:"#94a3b8" }}>
                  · Total : <strong style={{ color:"#0f172a",fontFamily:"'DM Mono',monospace" }}>{totalPrice.toLocaleString()} MGA</strong>
                </span>
              </div>
            </Field>

            <Field label={`Choisissez ${passengers} siège${passengers>1?"s":""} *`}>
              <SeatPicker
                totalSeats={totalSeats}
                takenSeats={takenSeats}
                selectedSeats={seatNums}
                onToggle={toggleSeat}
                maxSelectable={passengers}
              />
            </Field>

            <div style={{ background:"#f8fafc", border:"0.5px solid #e2e8f0", borderRadius:9, padding:"11px 14px", marginBottom:16, display:"flex", justifyContent:"space-between" }}>
              <span style={{ fontSize:13, color:"#64748b" }}>Prix total ({passengers} passager{passengers>1?"s":""})</span>
              <span style={{ fontSize:16, fontWeight:800, color:"#0f172a", fontFamily:"'DM Mono',monospace" }}>{totalPrice.toLocaleString()} MGA</span>
            </div>

            {error && <div style={{ color:"#dc2626", fontSize:12, marginBottom:12, display:"flex", alignItems:"center", gap:5 }}><Ico.Info />{error}</div>}

            <button
              style={{ width:"100%", padding:13, background:"#0f172a", color:"white", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit", opacity:loading?0.8:1 }}
              onClick={book} disabled={loading}
            >
              {loading ? <><SpinWhite/>Traitement…</> : "Continuer vers le paiement →"}
            </button>
          </>}

          {/* ─── STEP 2 ─── */}
          {step===2 && <>
            {/* Résumé des réservations créées */}
            <div style={{ background:"#f0fdf4", border:"1px solid #bbf7d0", borderRadius:10, padding:"12px 14px", marginBottom:18 }}>
              <div style={{ fontSize:10.5, color:"#16a34a", fontWeight:700, textTransform:"uppercase", letterSpacing:0.5, marginBottom:6 }}>
                {bookings.length > 1 ? `${bookings.length} Réservations créées` : "Référence de réservation"}
              </div>
              {bookings.length > 1 ? (
                <div style={{ display:"flex", flexDirection:"column", gap:4 }}>
                  {bookings.map((b, i) => (
                    <div key={i} style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                      <span style={{ fontFamily:"'DM Mono',monospace", fontSize:14, fontWeight:700, color:"#0f172a", letterSpacing:1 }}>
                        {b.reference}
                      </span>
                      <span style={{ fontSize:11, color:"#16a34a", fontWeight:600 }}>
                        Siège {String(seatNums[i] || "?").padStart(2,"0")}
                      </span>
                    </div>
                  ))}
                  <div style={{ marginTop:4, fontSize:11, color:"#64748b" }}>
                    Groupe : <strong style={{ fontFamily:"'DM Mono',monospace" }}>{groupRef}</strong>
                  </div>
                </div>
              ) : (
                <div style={{ fontFamily:"'DM Mono',monospace", fontSize:19, fontWeight:700, color:"#0f172a", letterSpacing:2 }}>
                  {bookings[0]?.reference || groupRef}
                </div>
              )}
            </div>

            <Field label="Opérateur *">
              <div style={{ display:"flex", gap:8, marginBottom:4, flexWrap:"wrap" }}>
                {OPERATORS.map(op => (
                  <button key={op} onClick={()=>setOp(op)} style={{ flex:1, padding:"9px 4px", borderRadius:9, fontSize:11.5, fontWeight:600, cursor:"pointer", fontFamily:"inherit", border:operator===op?"2px solid #16a34a":"1.5px solid #e2e8f0", background:operator===op?"#f0fdf4":"white", color:operator===op?"#16a34a":"#64748b", minWidth:90 }}>
                    {op}
                  </button>
                ))}
              </div>
            </Field>

            <OperatorPayBox operator={operator} amount={totalPrice} bookingRef={groupRef} />

            <Field label="Numéro de téléphone *">
              <input style={inp} placeholder="034 00 000 00" value={phone} onChange={e=>setPhone(e.target.value)} />
            </Field>

            <Field
              label="Référence de transaction *"
              hint="Envoyez d'abord le paiement via votre app Mobile Money, puis saisissez la référence reçue par SMS."
            >
              <input style={inp} placeholder="Ex : MVOLA-2026-XXXX" value={txRef} onChange={e=>setTxRef(e.target.value)} />
            </Field>

            {error && <div style={{ color:"#dc2626", fontSize:12, marginBottom:12, display:"flex", alignItems:"center", gap:5 }}><Ico.Info />{error}</div>}

            <button
              style={{ width:"100%", padding:13, background:"#16a34a", color:"white", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit", opacity:loading?0.8:1 }}
              onClick={pay} disabled={loading}
            >
              {loading ? <><SpinWhite/>Vérification…</> : "Valider le paiement →"}
            </button>
          </>}

          {/* ─── STEP 3 — Confirmation ─── */}
          {step===3 && (
            <div style={{ textAlign:"center", paddingTop:8 }}>
              <div style={{ width:56, height:56, background:"#f0fdf4", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px", color:"#16a34a", fontSize:22 }}>
                <Ico.Check />
              </div>
              <div style={{ fontSize:18, fontWeight:800, color:"#0f172a", marginBottom:8 }}>Paiement confirmé !</div>
              <div style={{ fontSize:13, color:"#64748b", marginBottom:20, lineHeight:1.7 }}>
                {seatNums.length > 1
                  ? `${seatNums.length} billets réservés avec succès.`
                  : "Billet réservé avec succès."
                }<br/>
                Siège{seatNums.length > 1 ? "s" : ""} :{" "}
                <strong>#{[...seatNums].sort((a,b)=>a-b).map(s=>String(s).padStart(2,"0")).join(", #")}</strong>
              </div>

              {/* Liste des billets */}
              <div style={{ background:"#f8fafc", border:"0.5px solid #e2e8f0", borderRadius:12, padding:"14px 16px", marginBottom:20, textAlign:"left" }}>
                <div style={{ fontSize:11, fontWeight:700, color:"#64748b", textTransform:"uppercase", letterSpacing:0.5, marginBottom:10 }}>
                  {bookings.length > 1 ? `${bookings.length} Billets` : "Récapitulatif"}
                </div>

                {bookings.length > 1 ? (
                  <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                    {bookings.map((b, i) => (
                      <div key={i} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", background:"white", border:"0.5px solid #e2e8f0", borderRadius:8, padding:"10px 12px" }}>
                        <div>
                          <div style={{ fontSize:11, color:"#94a3b8", marginBottom:2 }}>Billet {i+1}</div>
                          <div style={{ fontFamily:"'DM Mono',monospace", fontSize:13, fontWeight:700, color:"#0f172a" }}>{b.reference}</div>
                        </div>
                        <div style={{ textAlign:"right" }}>
                          <div style={{ fontSize:10, color:"#94a3b8", marginBottom:2 }}>Siège</div>
                          <div style={{ fontFamily:"'DM Mono',monospace", fontSize:20, fontWeight:700, color:"#16a34a" }}>
                            {String(seatNums[i] || "?").padStart(2,"0")}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                    {[
                      ["Passager",     fullName],
                      ["Trajet",       `${depName} → ${arrName}`],
                      ["Date",         trip.date || "—"],
                      ["Heure",        trip.departureTime || trip.time || "—"],
                      ["Transporteur", trip.transporter?.name || trip.transporter || "—"],
                      ["Opérateur",    operator],
                      ["Téléphone",    phone],
                      ["Prix total",   `${totalPrice.toLocaleString()} MGA`],
                    ].map(([k,v]) => (
                      <div key={k}>
                        <div style={{ fontSize:9.5, color:"#94a3b8", textTransform:"uppercase", letterSpacing:.5, fontWeight:700, marginBottom:2 }}>{k}</div>
                        <div style={{ fontSize:12, fontWeight:600, color:"#0f172a" }}>{v}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <button
  style={{ width:"100%", padding:13, background:"#0f172a", color:"white", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:8, marginBottom:10 }}
  onClick={() => {
    downloadTickets();
    setTimeout(() => { onSuccess?.(); onClose(); }, 300);
  }}
>
  <Ico.Down />
  {seatNums.length > 1
    ? `Télécharger mes ${seatNums.length} billets`
    : "Télécharger mon billet"}
</button>

              <button
                onClick={() => { onSuccess?.(); onClose(); }}
                style={{ width:"100%", padding:12, background:"none", border:"0.5px solid #e2e8f0", borderRadius:10, fontSize:13, color:"#64748b", cursor:"pointer", fontFamily:"inherit" }}
              >
                Fermer
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   RENTAL MODAL — Location de voiture
═══════════════════════════════════════════════════════════ */
const RentalModal = ({ car, onClose, onSuccess }) => {
  const [step,       setStep]    = useState(1);
  const [startDate,  setStart]   = useState("");
  const [endDate,    setEnd]     = useState("");
  const [pickup,     setPickup]  = useState("");
  const [dropoff,    setDropoff] = useState("");
  const [operator,   setOp]      = useState("");
  const [phone,      setPhone]   = useState("");
  const [txRef,      setTxRef]   = useState("");
  const [loading,    setLoading] = useState(false);
  const [error,      setError]   = useState("");
  const [bookingRef, setRef]     = useState("");

  const days = startDate && endDate
    ? Math.max(1, Math.round((new Date(endDate) - new Date(startDate)) / (1000*60*60*24)))
    : 0;
  const totalPrice = days * (car.dailyPrice || 0);

  const submitStep1 = () => {
    if (!startDate || !endDate) { setError("Sélectionnez les dates."); return; }
    if (new Date(endDate) <= new Date(startDate)) { setError("La date de fin doit être après la date de début."); return; }
    setError(""); setStep(2);
  };

  const submitStep2 = async () => {
    if (!operator || !phone || !txRef) { setError("Remplissez tous les champs."); return; }
    setLoading(true); setError("");
    try {
      setRef("MV-" + Math.random().toString(36).substr(2,6).toUpperCase());
      setStep(3);
      onSuccess?.();
    } catch(e) { setError(e?.response?.data?.error || "Erreur lors de la réservation."); }
    setLoading(false);
  };

  return (
    <div
      style={{ position:"fixed", inset:0, background:"rgba(15,23,42,0.55)", backdropFilter:"blur(4px)", zIndex:600, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}
      onClick={e => e.target===e.currentTarget && onClose()}
    >
      <div style={{ background:"white", borderRadius:16, width:"100%", maxWidth:480, maxHeight:"92vh", overflowY:"auto", boxShadow:"0 24px 80px rgba(0,0,0,0.15)" }}>
        <div style={{ padding:"20px 24px 14px", borderBottom:"0.5px solid #f1f5f9", display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
          <div>
            <div style={{ fontSize:16, fontWeight:800, color:"#0f172a", letterSpacing:-0.3 }}>
              {step===1 ? "Détails de la location" : step===2 ? "Paiement Mobile Money" : "Location confirmée ✓"}
            </div>
            <div style={{ fontSize:12, color:"#94a3b8", marginTop:3 }}>{car.brand} {car.model} · {car.year}</div>
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8", padding:4 }}><Ico.X /></button>
        </div>

        <div style={{ display:"flex", padding:"10px 24px", gap:6 }}>
          {["Dates","Paiement","Confirmation"].map((l,i) => (
            <div key={l} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
              <div style={{ width:"100%", height:3, borderRadius:4, background:step>i?"#1d4ed8":"#f1f5f9", transition:"background .3s" }} />
              <div style={{ fontSize:10, color:step>i?"#1d4ed8":"#94a3b8", fontWeight:600 }}>{l}</div>
            </div>
          ))}
        </div>

        <div style={{ padding:"8px 24px 24px" }}>
          {step===1 && <>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
              <Field label="Date de début *">
                <input type="date" style={inp} value={startDate} onChange={e=>setStart(e.target.value)} />
              </Field>
              <Field label="Date de fin *">
                <input type="date" style={inp} value={endDate} onChange={e=>setEnd(e.target.value)} />
              </Field>
            </div>
            <Field label="Lieu de prise en charge">
              <input style={inp} placeholder="Ex : Aéroport d'Ivato" value={pickup} onChange={e=>setPickup(e.target.value)} />
            </Field>
            <Field label="Lieu de restitution">
              <input style={inp} placeholder="Ex : Centre-ville Antananarivo" value={dropoff} onChange={e=>setDropoff(e.target.value)} />
            </Field>
            {days > 0 && (
              <div style={{ background:"#eff6ff", border:"0.5px solid #bfdbfe", borderRadius:9, padding:"12px 14px", marginBottom:14 }}>
                <div style={{ fontSize:12, color:"#1e40af", marginBottom:4 }}>
                  <strong>{days} jour{days>1?"s":""}</strong> de location
                </div>
                <div style={{ fontSize:16, fontWeight:800, color:"#0f172a", fontFamily:"'DM Mono',monospace" }}>
                  {totalPrice.toLocaleString()} MGA
                </div>
                <div style={{ fontSize:11, color:"#64748b", marginTop:2 }}>
                  {car.dailyPrice.toLocaleString()} MGA/jour × {days} jour{days>1?"s":""}
                </div>
              </div>
            )}
            <div style={{ background:"#f8fafc", borderRadius:9, padding:"11px 14px", marginBottom:14 }}>
              <div style={{ fontSize:11, color:"#64748b", marginBottom:6, fontWeight:700 }}>Équipements inclus</div>
              <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                {(car.features || []).map(f => (
                  <span key={f} style={{ fontSize:11, background:"white", border:"0.5px solid #e2e8f0", padding:"3px 9px", borderRadius:20, color:"#475569" }}>{f}</span>
                ))}
              </div>
            </div>
            {error && <div style={{ color:"#dc2626", fontSize:12, marginBottom:12 }}>{error}</div>}
            <button
              style={{ width:"100%", padding:13, background:"#1d4ed8", color:"white", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}
              onClick={submitStep1}
            >
              Continuer vers le paiement →
            </button>
          </>}

          {step===2 && <>
            <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:10, padding:"12px 14px", marginBottom:18 }}>
              <div style={{ fontSize:10.5, color:"#1d4ed8", fontWeight:700, textTransform:"uppercase", letterSpacing:0.5, marginBottom:4 }}>Montant total</div>
              <div style={{ fontFamily:"'DM Mono',monospace", fontSize:22, fontWeight:700, color:"#0f172a" }}>{totalPrice.toLocaleString()} MGA</div>
              <div style={{ fontSize:11, color:"#64748b", marginTop:2 }}>{days} jour{days>1?"s":""} · {car.brand} {car.model}</div>
            </div>
            <Field label="Opérateur *">
              <div style={{ display:"flex", gap:8, marginBottom:4, flexWrap:"wrap" }}>
                {OPERATORS.map(op => (
                  <button key={op} onClick={()=>setOp(op)} style={{ flex:1, padding:"9px 4px", borderRadius:9, fontSize:11.5, fontWeight:600, cursor:"pointer", fontFamily:"inherit", border:operator===op?"2px solid #1d4ed8":"1.5px solid #e2e8f0", background:operator===op?"#eff6ff":"white", color:operator===op?"#1d4ed8":"#64748b", minWidth:90 }}>
                    {op}
                  </button>
                ))}
              </div>
            </Field>
            <OperatorPayBox operator={operator} amount={totalPrice} />
            <Field label="Numéro de téléphone *">
              <input style={inp} placeholder="034 00 000 00" value={phone} onChange={e=>setPhone(e.target.value)} />
            </Field>
            <Field
              label="Référence de transaction *"
              hint="Envoyez d'abord le paiement via votre app Mobile Money, puis saisissez la référence reçue par SMS."
            >
              <input style={inp} placeholder="Ex : MVOLA-2026-XXXX" value={txRef} onChange={e=>setTxRef(e.target.value)} />
            </Field>
            {error && <div style={{ color:"#dc2626", fontSize:12, marginBottom:12 }}>{error}</div>}
            <button
              style={{ width:"100%", padding:13, background:"#1d4ed8", color:"white", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit", opacity:loading?0.8:1 }}
              onClick={submitStep2} disabled={loading}
            >
              {loading ? <><SpinWhite/>Traitement…</> : "Confirmer la location →"}
            </button>
          </>}

          {step===3 && (
            <div style={{ textAlign:"center", paddingTop:8 }}>
              <div style={{ width:56, height:56, background:"#eff6ff", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 16px", color:"#1d4ed8", fontSize:22 }}>
                <Ico.Key />
              </div>
              <div style={{ fontSize:18, fontWeight:800, color:"#0f172a", marginBottom:8 }}>Location confirmée !</div>
              <div style={{ fontSize:13, color:"#64748b", marginBottom:24, lineHeight:1.7 }}>
                {car.brand} {car.model} réservé pour <strong>{days} jour{days>1?"s":""}</strong>.<br/>
                Du <strong>{startDate}</strong> au <strong>{endDate}</strong><br/>
                {bookingRef && <>Réf : <strong style={{ fontFamily:"'DM Mono',monospace" }}>{bookingRef}</strong></>}
              </div>
              <button onClick={() => onClose()} style={{ width:"100%", padding:12, background:"none", border:"0.5px solid #e2e8f0", borderRadius:10, fontSize:13, color:"#64748b", cursor:"pointer", fontFamily:"inherit" }}>
                Fermer
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   PAGE — DASHBOARD (accueil)
═══════════════════════════════════════════════════════════ */
const DashboardHome = ({ user, stats, recentBookings, cities, goTo }) => {
  const [dep,       setDep]      = useState("");
  const [dest,      setDest]     = useState("");
  const [date,      setDate]     = useState("");
  const [trips,     setTrips]    = useState([]);
  const [searching, setSearch]   = useState(false);
  const [searched,  setSearched] = useState(false);
  const [booking,   setBooking]  = useState(null);

  const searchTrips = async () => {
    setSearch(true); setSearched(false);
    try {
      const r = await api.get("/dashboard/trips/search", { params:{ departure:dep, destination:dest, date } });
      setTrips(r.data);
    } catch { setTrips([]); }
    setSearched(true); setSearch(false);
  };

  const h = new Date().getHours();
  const greeting = h<12 ? "Bonjour" : h<18 ? "Bon après-midi" : "Bonsoir";
  const firstName = user?.name?.split(" ")[0] || "Voyageur";

  return (
    <div>
      <div style={{ background:"linear-gradient(135deg,#0f172a,#1e293b)", borderRadius:14, padding:"24px 28px", marginBottom:18, position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", right:-20, top:-20, width:160, height:160, borderRadius:"50%", background:"rgba(22,163,74,0.08)" }} />
        <div style={{ position:"absolute", right:40, bottom:-40, width:100, height:100, borderRadius:"50%", background:"rgba(22,163,74,0.05)" }} />
        <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", textTransform:"uppercase", letterSpacing:1, fontWeight:600, marginBottom:6 }}>TransTiGo · Voyageur</div>
        <h2 style={{ fontSize:22, fontWeight:800, color:"white", letterSpacing:-0.5, marginBottom:6 }}>{greeting}, {firstName} 👋</h2>
        <p style={{ fontSize:13, color:"rgba(255,255,255,0.5)", marginBottom:20 }}>Gérez vos trajets à travers Madagascar</p>
        <div style={{ display:"flex", gap:24, flexWrap:"wrap" }}>
          {[["Billets actifs", stats.tickets], ["Trajets", stats.trips], [`${Number(stats.payments||0).toLocaleString()} MGA`, "Dépenses"]].map(([v,l]) => (
            <div key={l}>
              <div style={{ fontSize:17, fontWeight:800, color:"white", fontFamily:"'DM Mono',monospace" }}>{v}</div>
              <div style={{ fontSize:11, color:"rgba(255,255,255,0.4)", marginTop:2 }}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      <Card>
        <CardHead title="Rechercher un trajet" badge={<GrayBadge>Taxi-brousse · Covoiturage</GrayBadge>} />
        <div className="search-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr auto", gap:12, alignItems:"end" }}>
          <Field label={<><Ico.Pin /> Départ</>}>
            <select style={sel} value={dep} onChange={e=>setDep(e.target.value)}>
              <option value="">Choisir une ville</option>
              {cities.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </Field>
          <Field label={<><Ico.Pin /> Destination</>}>
            <select style={sel} value={dest} onChange={e=>setDest(e.target.value)}>
              <option value="">Choisir une ville</option>
              {cities.filter(c=>c.id!==Number(dep)).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </Field>
          <Field label="📅 Date">
            <input type="date" style={inp} value={date} onChange={e=>setDate(e.target.value)} />
          </Field>
          <div style={{ display:"flex", alignItems:"flex-end", paddingBottom:14 }}>
            <button
              style={{ display:"flex", alignItems:"center", gap:6, padding:"10px 20px", background:"#16a34a", color:"white", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit", opacity:searching?0.7:1, width:"100%" }}
              onClick={searchTrips} disabled={searching} className="green-btn"
            >
              {searching ? <><SpinWhite/>…</> : <><Ico.Search/>Rechercher</>}
            </button>
          </div>
        </div>
      </Card>

      {searched && (
        <Card>
          <CardHead title="Résultats" badge={<GreenBadge n={trips.length} label={`trajet${trips.length!==1?"s":""}`} />} />
          {trips.length===0 ? (
            <div style={{ textAlign:"center", padding:"32px 0" }}>
              <div style={{ fontSize:32, marginBottom:8 }}>🔍</div>
              <div style={{ fontSize:14, color:"#64748b", marginBottom:12 }}>Aucun trajet disponible pour cette recherche.</div>
              <button
                style={{ display:"inline-flex", alignItems:"center", gap:6, padding:"9px 18px", background:"white", border:"0.5px solid #e2e8f0", borderRadius:9, fontSize:13, color:"#64748b", cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}
                onClick={() => goTo("carpooling")}
              >
                <Ico.Car /> Voir les covoiturages
              </button>
            </div>
          ) : (
            <div style={{ display:"grid", gap:12 }}>
              {trips.map(t => (
                <div key={t.id} style={{ border:"0.5px solid #e2e8f0", borderRadius:10, overflow:"hidden", background:"white" }} className="trip-row-card">
                  {t.photos && t.photos.length > 0 && (
                    <div style={{ padding:"12px 12px 0" }}>
                      <VehiclePhotos photos={t.photos} />
                    </div>
                  )}
                  <div style={{ padding:"14px 18px", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:12 }}>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6, flexWrap:"wrap" }}>
                        <span style={{ fontSize:15, fontWeight:800, color:"#0f172a" }}>{t.departure?.name}</span>
                        <span style={{ color:"#94a3b8" }}><Ico.Arrow /></span>
                        <span style={{ fontSize:15, fontWeight:800, color:"#0f172a" }}>{t.arrival?.name}</span>
                        <TypeBadge type={t.type || "taxi-brousse"} />
                      </div>
                      <div style={{ display:"flex", gap:12, fontSize:12, color:"#64748b", flexWrap:"wrap", alignItems:"center" }}>
                        <span style={{ display:"flex", alignItems:"center", gap:4 }}><Ico.Clock />{t.departureTime}</span>
                        <span style={{ display:"flex", alignItems:"center", gap:4 }}><Ico.Users />{t.seats} places</span>
                        <span style={{ display:"flex", alignItems:"center", gap:4 }}><Ico.Star />{t.transporter?.name||"—"}</span>
                        {t.transporter?.phone && (
                          <span style={{ display:"flex", alignItems:"center", gap:4, color:"#16a34a", fontWeight:600 }}>
                            <Ico.Phone />{t.transporter.phone}
                          </span>
                        )}
                      </div>
                    </div>
                    <div style={{ display:"flex", alignItems:"center", gap:14, flexShrink:0 }}>
                      <div style={{ textAlign:"right" }}>
                        <div style={{ fontFamily:"'DM Mono',monospace", fontSize:18, fontWeight:700, color:"#16a34a" }}>{Number(t.price).toLocaleString()}</div>
                        <div style={{ fontSize:10, color:"#94a3b8" }}>MGA</div>
                      </div>
                      <button
                        style={{ padding:"9px 20px", background:"#16a34a", color:"white", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}
                        onClick={() => setBooking(t)} className="green-btn"
                      >
                        Réserver
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </Card>
      )}

      <div className="teasers-grid" style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:12, marginBottom:16 }}>
        <div style={{ background:"linear-gradient(135deg,#f0fdf4,#dcfce7)", border:"0.5px solid #bbf7d0", borderRadius:12, padding:"14px 16px", cursor:"pointer" }} onClick={() => goTo("carpooling")} className="teaser">
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
            <div style={{ width:36, height:36, borderRadius:9, background:"#16a34a", color:"white", display:"flex", alignItems:"center", justifyContent:"center" }}><Ico.Car /></div>
            <div style={{ fontSize:13, fontWeight:700, color:"#0f172a" }}>Covoiturage</div>
          </div>
          <div style={{ fontSize:11, color:"#64748b" }}>Partagez un trajet et réduisez vos coûts</div>
        </div>
        <div style={{ background:"linear-gradient(135deg,#eff6ff,#dbeafe)", border:"0.5px solid #bfdbfe", borderRadius:12, padding:"14px 16px", cursor:"pointer" }} onClick={() => goTo("rentals")} className="teaser">
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
            <div style={{ width:36, height:36, borderRadius:9, background:"#1d4ed8", color:"white", display:"flex", alignItems:"center", justifyContent:"center" }}><Ico.Key /></div>
            <div style={{ fontSize:13, fontWeight:700, color:"#0f172a" }}>Location voiture</div>
          </div>
          <div style={{ fontSize:11, color:"#64748b" }}>Liberté de mouvement à votre rythme</div>
        </div>
        <div style={{ background:"linear-gradient(135deg,#fdf4ff,#fae8ff)", border:"0.5px solid #e9d5ff", borderRadius:12, padding:"14px 16px", cursor:"pointer" }} onClick={() => goTo("tickets")} className="teaser">
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
            <div style={{ width:36, height:36, borderRadius:9, background:"#7c3aed", color:"white", display:"flex", alignItems:"center", justifyContent:"center" }}><Ico.Ticket /></div>
            <div style={{ fontSize:13, fontWeight:700, color:"#0f172a" }}>Mes billets</div>
          </div>
          <div style={{ fontSize:11, color:"#64748b" }}>Consultez et téléchargez vos billets</div>
        </div>
      </div>

      <Card>
        <CardHead
          title="Réservations récentes"
          badge={<GrayBadge>5 dernières</GrayBadge>}
          action={<button style={{ fontSize:12, color:"#16a34a", background:"none", border:"none", cursor:"pointer", fontFamily:"inherit", fontWeight:600 }} onClick={() => goTo("tickets")}>Voir tout →</button>}
        />
        {recentBookings.length===0 ? (
          <div style={{ textAlign:"center", padding:"32px 0" }}>
            <div style={{ fontSize:32, marginBottom:8 }}>🎫</div>
            <div style={{ fontSize:14, color:"#64748b" }}>Aucune réservation pour l'instant</div>
          </div>
        ) : (
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead><tr>{["Trajet","Date","Statut"].map(h=><Th key={h}>{h}</Th>)}</tr></thead>
              <tbody>
                {recentBookings.map((b,i) => (
                  <tr key={i} className="trow">
                    <Td>
                      <div style={{ display:"flex", alignItems:"center", gap:5 }}>
                        <Pill>{b.route?.split("→")[0]?.trim()}</Pill>
                        <span style={{ color:"#cbd5e1", fontSize:9 }}><Ico.Arrow /></span>
                        <Pill>{b.route?.split("→")[1]?.trim()||b.route}</Pill>
                      </div>
                    </Td>
                    <Td style={{ color:"#64748b", fontSize:12 }}>{b.date}</Td>
                    <Td><StatusBadge status={b.status} /></Td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>

      {booking && <BookingModal trip={booking} onClose={() => setBooking(null)} onSuccess={() => setBooking(null)} />}
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   PAGE — TICKETS
═══════════════════════════════════════════════════════════ */
const TicketsPage = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const r = await api.get("/dashboard/recent-bookings?limit=50"); setTickets(r.data); }
      catch { setTickets([]); }
      setLoading(false);
    })();
  }, []);

  const downloadTicket = (b) => {
    const [dep, arr] = (b.route||"—→—").split("→").map(s=>s.trim());
    const fakeTrip = {
      departure: { name: dep },
      arrival:   { name: arr },
      date:      b.date || "",
      departureTime: b.departureTime || b.time || "",
      transporter: { name: b.transporter || "", phone: b.transporterPhone || "" },
      price:     b.price || 0,
      type:      b.type || "taxi-brousse",
    };
    const w = window.open("", "_blank");
    if (w) {
      w.document.write(buildTicketHTML({
        seats:     [b.seatNumber || b.seat || "?"],
        trip:      fakeTrip,
        fullName:  b.passengerName || b.fullName || "—",
        bookings:  [{ bookingId: b.id, reference: b.reference || b.bookingRef || "—", seatNumber: b.seatNumber }],
        operator:  b.operator || "—",
        phone:     b.phoneNumber || "—",
        txRef:     b.transactionReference || "—",
        totalPrice: b.amount || b.price || 0,
        passengers: b.quantity || 1,
      }));
      w.document.close();
    }
  };

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:21, fontWeight:800, color:"#0f172a", letterSpacing:-0.5, marginBottom:4 }}>Mes billets</h1>
        <p style={{ fontSize:12, color:"#94a3b8" }}>Historique de toutes vos réservations</p>
      </div>
      <Card>
        {loading ? (
          <div style={{ textAlign:"center", padding:"40px 0", color:"#94a3b8" }}><SpinGreen />Chargement…</div>
        ) : tickets.length === 0 ? (
          <div style={{ textAlign:"center", padding:"40px 0" }}>
            <div style={{ fontSize:36, marginBottom:10 }}>🎫</div>
            <div style={{ fontSize:14, color:"#64748b" }}>Aucun billet pour l'instant</div>
          </div>
        ) : (
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead>
                <tr>{["Trajet","Type","Date","Siège","Statut","Billet"].map(h=><Th key={h}>{h}</Th>)}</tr>
              </thead>
              <tbody>
                {tickets.map((b,i) => {
                  const [dep,arr] = (b.route||"—→—").split("→").map(s=>s.trim());
                  return (
                    <tr key={i} className="trow">
                      <Td>
                        <div style={{ display:"flex", alignItems:"center", gap:5 }}>
                          <Pill>{dep}</Pill>
                          <span style={{ color:"#cbd5e1", fontSize:9 }}><Ico.Arrow /></span>
                          <Pill>{arr}</Pill>
                        </div>
                      </Td>
                      <Td><TypeBadge type={b.type || "taxi-brousse"} /></Td>
                      <Td style={{ color:"#64748b", fontSize:12 }}>{b.date}</Td>
                      <Td>
                        {b.seatNumber
                          ? <span style={{ fontFamily:"'DM Mono',monospace", fontWeight:700, fontSize:13, color:"#16a34a" }}>#{String(b.seatNumber).padStart(2,"0")}</span>
                          : <span style={{ color:"#94a3b8" }}>—</span>
                        }
                      </Td>
                      <Td><StatusBadge status={b.status} /></Td>
                      <Td>
                        {b.status==="CONFIRMED" && (
                          <button
                            style={{ display:"inline-flex", alignItems:"center", gap:5, fontSize:11, padding:"5px 12px", borderRadius:7, background:"#f0fdf4", color:"#16a34a", border:"0.5px solid #bbf7d0", cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}
                            onClick={() => downloadTicket(b)}
                          >
                            <Ico.Down /> Télécharger
                          </button>
                        )}
                      </Td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   PAGE — ROUTES
═══════════════════════════════════════════════════════════ */
const RoutesPage = ({ cities }) => {
  const [dep,      setDep]      = useState("");
  const [dest,     setDest]     = useState("");
  const [date,     setDate]     = useState("");
  const [trips,    setTrips]    = useState([]);
  const [loading,  setLoad]     = useState(false);
  const [searched, setSearched] = useState(false);
  const [booking,  setBooking]  = useState(null);
  const [toast,    setToast]    = useState(null);

  const doSearch = async () => {
    setLoad(true); setSearched(false);
    try {
      const r = await api.get("/dashboard/trips/search", { params:{ departure:dep, destination:dest, date } });
      setTrips(r.data);
    } catch { setTrips([]); }
    setSearched(true); setLoad(false);
    setTimeout(() => document.getElementById("rresults")?.scrollIntoView({ behavior:"smooth" }), 100);
  };

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:21, fontWeight:800, color:"#0f172a", letterSpacing:-0.5, marginBottom:4 }}>Mes trajets</h1>
        <p style={{ fontSize:12, color:"#94a3b8" }}>Recherchez et réservez votre prochain voyage</p>
      </div>
      <Card>
        <CardHead title="Rechercher un trajet" />
        <div className="form-grid2" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
          <Field label="Ville de départ">
            <select style={sel} value={dep} onChange={e=>setDep(e.target.value)}>
              <option value="">Sélectionner…</option>
              {cities.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </Field>
          <Field label="Ville d'arrivée">
            <select style={sel} value={dest} onChange={e=>setDest(e.target.value)}>
              <option value="">Sélectionner…</option>
              {cities.filter(c=>c.id!==Number(dep)).map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </Field>
        </div>
        <Field label="Date du voyage">
          <input type="date" style={{ ...inp, maxWidth:220 }} value={date} onChange={e=>setDate(e.target.value)} />
        </Field>
        <button
          style={{ display:"flex", alignItems:"center", gap:7, padding:"11px 24px", background:"#16a34a", color:"white", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit", opacity:loading?0.7:1 }}
          onClick={doSearch} disabled={loading} className="green-btn"
        >
          {loading ? <><SpinWhite/>Recherche…</> : <><Ico.Search/>Rechercher les trajets</>}
        </button>
      </Card>

      {searched && (
        <Card id="rresults">
          <CardHead title="Trajets disponibles" badge={<GreenBadge n={trips.length} label="résultats" />} />
          {trips.length===0 ? (
            <div style={{ textAlign:"center", padding:"40px 0", color:"#94a3b8" }}>
              <div style={{ fontSize:36, marginBottom:10 }}>🚌</div>
              <div>Aucun trajet trouvé.</div>
            </div>
          ) : (
            <div style={{ display:"grid", gap:12 }}>
              {trips.map(t => (
                <div key={t.id} style={{ border:"0.5px solid #e2e8f0", borderRadius:10, overflow:"hidden" }} className="trip-row-card">
                  {t.photos && t.photos.length > 0 && <VehiclePhotos photos={t.photos} />}
                  <div style={{ padding:"14px 18px", display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:12 }}>
                    <div>
                      <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:6, flexWrap:"wrap" }}>
                        <span style={{ fontSize:15, fontWeight:800, color:"#0f172a" }}>{t.departure?.name}</span>
                        <span style={{ color:"#94a3b8" }}><Ico.Arrow /></span>
                        <span style={{ fontSize:15, fontWeight:800, color:"#0f172a" }}>{t.arrival?.name}</span>
                        <TypeBadge type={t.type || "taxi-brousse"} />
                      </div>
                      <div style={{ display:"flex", gap:12, fontSize:12, color:"#64748b", flexWrap:"wrap" }}>
                        <span style={{ display:"flex", alignItems:"center", gap:4 }}><Ico.Clock />{t.departureTime}</span>
                        <span style={{ display:"flex", alignItems:"center", gap:4 }}><Ico.Users />{t.seats} places</span>
                        <span style={{ display:"flex", alignItems:"center", gap:4 }}><Ico.Star />{t.transporter?.name||"—"}</span>
                      </div>
                    </div>
                    <div style={{ display:"flex", alignItems:"center", gap:14 }}>
                      <div style={{ textAlign:"right" }}>
                        <div style={{ fontFamily:"'DM Mono',monospace", fontSize:18, fontWeight:700, color:"#16a34a" }}>{Number(t.price).toLocaleString()}</div>
                        <div style={{ fontSize:10, color:"#94a3b8" }}>MGA</div>
                      </div>
                      <button
                        style={{ padding:"9px 20px", background:"#0f172a", color:"white", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit" }}
                        onClick={() => setBooking(t)} className="dark-btn"
                      >
                        Réserver
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </Card>
      )}

      {booking && (
        <BookingModal
          trip={booking}
          onClose={() => setBooking(null)}
          onSuccess={() => {
            setBooking(null);
            setToast({ type:"success", msg:"Réservation confirmée !" });
            setTimeout(() => setToast(null), 3500);
          }}
        />
      )}
      <Toast t={toast} />
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   PAGE — CARPOOLING
═══════════════════════════════════════════════════════════ */
const CarpoolingPage = ({ cities, user }) => {
  const [view,     setView]     = useState("browse");
  const [carpools, setCarpools] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [filter,   setFilter]   = useState("all");
  const [toast,    setToast]    = useState(null);

  const [stops,      setStops]    = useState([{ cityId:"", time:"" }, { cityId:"", time:"" }]);
  const [form,       setForm]     = useState({ price:"", seats:"", departureDate:"", description:"" });
  const [submitting, setSubmit]   = useState(false);

  const showToast = (type, msg) => { setToast({ type, msg }); setTimeout(()=>setToast(null), 3500); };

  const load = useCallback(async () => {
    setLoading(true);
    try { const r = await api.get("/dashboard/list"); setCarpools(r.data); }
    catch { setCarpools([]); }
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const today    = new Date().toISOString().split("T")[0];
  const filtered = carpools.filter(c => {
    if (filter==="today") return c.departureDate?.startsWith(today);
    if (filter==="seats") return (c.seats||0)>0;
    return true;
  });

  const addStop    = ()        => setStops([...stops, { cityId:"", time:"" }]);
  const removeStop = (i)       => setStops(stops.filter((_,idx)=>idx!==i));
  const updateStop = (i, f, v) => { const u=[...stops]; u[i][f]=v; setStops(u); };

  const submitCarpool = async () => {
    if (stops.some(s=>!s.cityId))       return showToast("error","Sélectionnez une ville pour chaque étape.");
    if (!form.departureDate)            return showToast("error","Date de départ requise.");
    if (!form.price || form.price<=0)   return showToast("error","Prix invalide.");
    if (!form.seats || form.seats<=0)   return showToast("error","Nombre de places invalide.");
    const ids = stops.map(s=>s.cityId);
    if (new Set(ids).size!==ids.length) return showToast("error","Deux étapes ne peuvent pas avoir la même ville.");
    setSubmit(true);
    try {
      await api.post("/transporter/carpooling", {
        itinerary: stops.map(s=>({ cityId:s.cityId, time:s.time })),
        price: Number(form.price), seats: Number(form.seats),
        departureDate: form.departureDate, description: form.description,
      });
      setStops([{ cityId:"", time:"" }, { cityId:"", time:"" }]);
      setForm({ price:"", seats:"", departureDate:"", description:"" });
      showToast("success","Covoiturage publié avec succès !");
      load();
      setView("browse");
    } catch { showToast("error","Erreur lors de la publication."); }
    setSubmit(false);
  };

  return (
    <div>
      <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:20, flexWrap:"wrap", gap:12 }}>
        <div>
          <h1 style={{ fontSize:21, fontWeight:800, color:"#0f172a", letterSpacing:-0.5, marginBottom:4 }}>Covoiturage</h1>
          <p style={{ fontSize:12, color:"#94a3b8" }}>{view==="browse"?"Partagez la route avec d'autres voyageurs":"Proposez votre trajet"}</p>
        </div>
        <div style={{ display:"flex", gap:8 }}>
          <button style={{ fontSize:12, padding:"8px 16px", borderRadius:9, border:"0.5px solid #e2e8f0", background:view==="browse"?"#0f172a":"none", color:view==="browse"?"white":"#64748b", cursor:"pointer", fontFamily:"inherit", fontWeight:600 }} onClick={()=>setView("browse")}>
            Voir les trajets
          </button>
          <button style={{ fontSize:12, padding:"8px 16px", borderRadius:9, border:"0.5px solid #e2e8f0", background:view==="propose"?"#16a34a":"none", color:view==="propose"?"white":"#64748b", cursor:"pointer", fontFamily:"inherit", fontWeight:600, display:"flex", alignItems:"center", gap:5 }} onClick={()=>setView("propose")}>
            <Ico.Plus /> Proposer un trajet
          </button>
        </div>
      </div>

      {view==="browse" && (
        <>
          <div style={{ display:"flex", gap:6, marginBottom:16, flexWrap:"wrap" }}>
            {[["all","Tous"],["today","Aujourd'hui"],["seats","Places dispo"]].map(([v,l])=>(
              <button key={v} style={{ fontSize:11, padding:"6px 14px", borderRadius:20, border:"0.5px solid #e2e8f0", background:filter===v?"#0f172a":"none", color:filter===v?"white":"#64748b", cursor:"pointer", fontFamily:"inherit" }} onClick={()=>setFilter(v)}>
                {l}
              </button>
            ))}
          </div>
          {loading ? (
            <div style={{ textAlign:"center", padding:"60px 0", color:"#94a3b8" }}><SpinGreen />Chargement…</div>
          ) : filtered.length===0 ? (
            <div style={{ textAlign:"center", padding:"60px 0" }}>
              <div style={{ fontSize:40, marginBottom:10 }}>🚗</div>
              <div style={{ fontSize:14, color:"#64748b" }}>Aucun covoiturage disponible</div>
            </div>
          ) : (
            <div className="cp-grid" style={{ display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:14 }}>
              {filtered.map(c => <CarpoolCard key={c.id} c={c} onBook={load} />)}
            </div>
          )}
        </>
      )}

      {view==="propose" && (
        <div className="coop-grid" style={{ display:"grid", gridTemplateColumns:"1fr 340px", gap:16, alignItems:"start" }}>
          <Card>
            <div style={{ fontSize:14, fontWeight:700, color:"#0f172a", marginBottom:18 }}>Itinéraire du trajet</div>
            <div style={{ position:"relative" }}>
              <div style={{ position:"absolute", left:18, top:20, bottom:20, width:1.5, background:"linear-gradient(to bottom,#16a34a,#e2e8f0)", borderRadius:2 }} />
              {stops.map((stop,i) => {
                const isFirst=i===0, isLast=i===stops.length-1;
                return (
                  <div key={i} style={{ display:"flex", gap:14, alignItems:"flex-start", marginBottom:14 }}>
                    <div style={{ width:36, height:36, borderRadius:"50%", flexShrink:0, zIndex:1, position:"relative", background:isFirst?"#16a34a":isLast?"#0f172a":"white", border:`2px solid ${isFirst||isLast?"transparent":"#e2e8f0"}`, display:"flex", alignItems:"center", justifyContent:"center", color:isFirst||isLast?"white":"#64748b", fontWeight:800, fontSize:12 }}>
                      {isFirst?"A":isLast?"B":i}
                    </div>
                    <div style={{ flex:1, display:"grid", gridTemplateColumns:"1fr 120px auto", gap:8, alignItems:"center" }}>
                      <select style={sel} value={stop.cityId} onChange={e=>updateStop(i,"cityId",e.target.value)}>
                        <option value="">{isFirst?"Départ":isLast?"Arrivée":`Étape ${i}`}</option>
                        {cities.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
                      </select>
                      <input type="time" style={inp} value={stop.time} onChange={e=>updateStop(i,"time",e.target.value)} />
                      {!isFirst && !isLast && (
                        <button onClick={()=>removeStop(i)} style={{ background:"none", border:"none", color:"#dc2626", cursor:"pointer", padding:"4px 6px" }}><Ico.Trash /></button>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
            <button style={{ display:"inline-flex", alignItems:"center", gap:6, padding:"8px 16px", background:"none", border:"0.5px solid #e2e8f0", borderRadius:9, fontSize:12, color:"#64748b", cursor:"pointer", fontFamily:"inherit", marginTop:4 }} onClick={addStop}>
              <Ico.Plus /> Ajouter une étape intermédiaire
            </button>
          </Card>
          <Card>
            <div style={{ fontSize:14, fontWeight:700, color:"#0f172a", marginBottom:16 }}>Détails</div>
            <Field label="Date de départ *">
              <input type="date" style={inp} value={form.departureDate} onChange={e=>setForm({...form,departureDate:e.target.value})} />
            </Field>
            <Field label="Prix par personne (MGA) *">
              <input type="number" style={inp} placeholder="Ex : 5 000" value={form.price} onChange={e=>setForm({...form,price:e.target.value})} />
            </Field>
            <Field label="Places disponibles *">
              <input type="number" style={inp} placeholder="Ex : 3" value={form.seats} onChange={e=>setForm({...form,seats:e.target.value})} />
            </Field>
            <Field label="Description (optionnel)">
              <textarea style={{ ...inp, height:72, resize:"vertical", lineHeight:1.6 }} placeholder="Climatisation, animaux acceptés…" value={form.description} onChange={e=>setForm({...form,description:e.target.value})} />
            </Field>
            <button
              style={{ width:"100%", padding:12, background:"#16a34a", color:"white", border:"none", borderRadius:10, fontSize:14, fontWeight:700, cursor:"pointer", fontFamily:"inherit", marginTop:4, display:"flex", alignItems:"center", justifyContent:"center", gap:8, opacity:submitting?0.7:1 }}
              onClick={submitCarpool} disabled={submitting} className="green-btn"
            >
              {submitting ? <><SpinWhite/>Publication…</> : <><Ico.Car/>Publier le covoiturage</>}
            </button>
          </Card>
        </div>
      )}
      <Toast t={toast} />
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   CARPOOL CARD
═══════════════════════════════════════════════════════════ */
const CarpoolCard = ({ c, onBook }) => {
  const [booked,  setBooked]  = useState(false);
  const [showPay, setShowPay] = useState(false);
  const [op,      setOp]      = useState("");
  const [loading, setLoading] = useState(false);
  const stops = c.itinerary ?? [];
  const dep = stops[0]?.city ?? "—";
  const arr = stops[stops.length-1]?.city ?? "—";
  const mid = stops.slice(1,-1);

  const book = async () => {
    setLoading(true);
    try { await api.post(`/dashboard/${c.id}/book`, { operator:op }); setBooked(true); setShowPay(false); onBook?.(); }
    catch {}
    setLoading(false);
  };

  return (
    <div style={{ background:"white", border:"0.5px solid #e2e8f0", borderRadius:14, padding:"20px 22px" }} className="cp-card">
      <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:10 }}>
        <div>
          <div style={{ display:"flex", alignItems:"center", gap:7, marginBottom:5, flexWrap:"wrap" }}>
            <span style={{ fontSize:15, fontWeight:800, color:"#0f172a" }}>{dep}</span>
            <span style={{ color:"#94a3b8", fontSize:10 }}><Ico.Arrow /></span>
            <span style={{ fontSize:15, fontWeight:800, color:"#0f172a" }}>{arr}</span>
          </div>
          {mid.length>0 && (
            <div style={{ display:"flex", alignItems:"center", gap:4, flexWrap:"wrap" }}>
              {mid.map((m,i) => (
                <React.Fragment key={i}>
                  <span style={{ fontSize:11, background:"#f1f5f9", padding:"2px 7px", borderRadius:5, color:"#475569" }}>{m.city}</span>
                  {i<mid.length-1 && <span style={{ color:"#cbd5e1", fontSize:9 }}>›</span>}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
        <div style={{ textAlign:"right", flexShrink:0 }}>
          <div style={{ fontFamily:"'DM Mono',monospace", fontSize:16, fontWeight:700, color:"#16a34a" }}>{Number(c.price).toLocaleString()}</div>
          <div style={{ fontSize:10, color:"#94a3b8" }}>MGA / pers.</div>
        </div>
      </div>

      {stops.length>1 && (
        <div style={{ display:"flex", alignItems:"flex-start", gap:0, marginBottom:12, overflow:"hidden" }}>
          {stops.map((stop,i) => (
            <React.Fragment key={i}>
              <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:1, flexShrink:0 }}>
                <div style={{ width:7, height:7, borderRadius:"50%", background:i===0||i===stops.length-1?"#16a34a":"#e2e8f0", border:"2px solid white", boxShadow:"0 0 0 1px #16a34a" }} />
                <div style={{ fontSize:9.5, fontWeight:600, color:"#475569", whiteSpace:"nowrap", maxWidth:60, overflow:"hidden", textOverflow:"ellipsis", textAlign:"center" }}>{stop.city}</div>
                {stop.time && <div style={{ fontSize:9, color:"#94a3b8", fontFamily:"'DM Mono',monospace" }}>{stop.time}</div>}
              </div>
              {i<stops.length-1 && <div style={{ flex:1, height:1, background:"#e2e8f0", margin:"3px 2px 0" }} />}
            </React.Fragment>
          ))}
        </div>
      )}

      <div style={{ display:"flex", gap:7, marginBottom:12, flexWrap:"wrap" }}>
        <MetaChip><Ico.Users />{c.seats} places</MetaChip>
        {c.departureDate && <MetaChip><Ico.Clock />{new Date(c.departureDate).toLocaleDateString("fr-FR")}</MetaChip>}
        {c.transporterName && <MetaChip yellow><Ico.Star />{c.transporterName}</MetaChip>}
      </div>
      {c.description && <p style={{ fontSize:12, color:"#64748b", lineHeight:1.6, marginBottom:12, fontStyle:"italic" }}>"{c.description}"</p>}

      {booked ? (
        <div style={{ background:"#f0fdf4", border:"0.5px solid #bbf7d0", borderRadius:9, padding:"10px 14px", fontSize:12, color:"#16a34a", fontWeight:700, textAlign:"center" }}>
          ✓ Réservation confirmée
        </div>
      ) : !showPay ? (
        <button
          style={{ width:"100%", padding:"10px 0", background:"#0f172a", color:"white", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:6 }}
          onClick={()=>setShowPay(true)} className="dark-btn"
        >
          Réserver ce covoiturage <Ico.Chev />
        </button>
      ) : (
        <div style={{ background:"#f8fafc", border:"0.5px solid #e2e8f0", borderRadius:10, padding:"14px" }}>
          <div style={{ fontSize:12, fontWeight:600, color:"#475569", marginBottom:8 }}>Opérateur de paiement</div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginBottom:8 }}>
            {OPERATORS.map(o=>(
              <button key={o} onClick={()=>setOp(o)} style={{ fontSize:11, padding:"5px 12px", borderRadius:20, cursor:"pointer", fontFamily:"inherit", fontWeight:600, background:op===o?"#16a34a":"#f8fafc", color:op===o?"white":"#64748b", border:`0.5px solid ${op===o?"#16a34a":"#e2e8f0"}` }}>
                {o}
              </button>
            ))}
          </div>
          {op && OPERATOR_NUMBERS[op] && (
            <div style={{ background:"#0f172a", borderRadius:8, padding:"10px 12px", marginBottom:10 }}>
              <div style={{ fontSize:9, color:"rgba(255,255,255,0.4)", textTransform:"uppercase", letterSpacing:0.5, marginBottom:3 }}>
                Envoyez {Number(c.price).toLocaleString()} MGA au
              </div>
              <div style={{ fontFamily:"'DM Mono',monospace", fontSize:16, color:"white", letterSpacing:1.5 }}>
                {OPERATOR_NUMBERS[op]}
              </div>
            </div>
          )}
          <div style={{ display:"flex", gap:8 }}>
            <button style={{ display:"flex", alignItems:"center", gap:5, padding:"9px 14px", background:"none", border:"0.5px solid #e2e8f0", borderRadius:9, fontSize:12, color:"#64748b", cursor:"pointer", fontFamily:"inherit" }} onClick={()=>setShowPay(false)}>
              <Ico.X />Annuler
            </button>
            <button
              style={{ flex:1, padding:"9px 0", background:"#16a34a", color:"white", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", opacity:loading?0.7:1 }}
              onClick={book} disabled={loading} className="green-btn"
            >
              {loading?<><SpinWhite/>…</>:"Confirmer"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   PAGE — LOCATION VOITURE
═══════════════════════════════════════════════════════════ */
const RentalsPage = () => {
  const [cars,    setCars]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [rental,  setRental]  = useState(null);
  const [toast,   setToast]   = useState(null);

  useEffect(() => {
    (async () => {
      try { const r = await api.get("/dashboard/rentals"); setCars(r.data); }
      catch { setCars([]); }
      setLoading(false);
    })();
  }, []);

  const reload = async () => {
    try { const r = await api.get("/dashboard/rentals"); setCars(r.data); } catch {}
  };

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:21, fontWeight:800, color:"#0f172a", letterSpacing:-0.5, marginBottom:4 }}>Location de voiture</h1>
        <p style={{ fontSize:12, color:"#94a3b8" }}>Choisissez un véhicule pour votre voyage à Madagascar</p>
      </div>
      {loading ? (
        <div style={{ textAlign:"center", padding:"60px 0", color:"#94a3b8" }}><SpinGreen />Chargement des véhicules…</div>
      ) : cars.length===0 ? (
        <div style={{ textAlign:"center", padding:"60px 0" }}>
          <div style={{ fontSize:40, marginBottom:10 }}>🚗</div>
          <div style={{ fontSize:14, color:"#64748b" }}>Aucun véhicule disponible pour l'instant</div>
        </div>
      ) : (
        <div className="car-grid" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:16 }}>
          {cars.map(car => (
            <div key={car.id} style={{ background:"white", border:"0.5px solid #e2e8f0", borderRadius:14, overflow:"hidden" }} className="car-card">
              {car.photos && car.photos.length > 0 ? (
                <div style={{ padding:"12px 12px 0" }}>
                  <VehiclePhotos photos={car.photos} />
                </div>
              ) : (
                <div style={{ width:"100%", height:160, background:"linear-gradient(135deg,#f1f5f9,#e2e8f0)", display:"flex", alignItems:"center", justifyContent:"center", position:"relative" }}>
                  <div style={{ fontSize:48, color:"#94a3b8" }}>🚗</div>
                  <div style={{ position:"absolute", top:10, right:10 }}>
                    {car.availability === "available"
                      ? <span style={{ fontSize:10, padding:"3px 9px", borderRadius:20, background:"#f0fdf4", color:"#16a34a", border:"0.5px solid #bbf7d0", fontWeight:600 }}>● Disponible</span>
                      : <span style={{ fontSize:10, padding:"3px 9px", borderRadius:20, background:"#fff5f5", color:"#dc2626", border:"0.5px solid #fecaca", fontWeight:600 }}>● Loué</span>
                    }
                  </div>
                </div>
              )}
              {car.photos && car.photos.length > 0 && (
                <div style={{ padding:"0 12px", marginTop:4, marginBottom:-4, display:"flex", justifyContent:"flex-end" }}>
                  {car.availability === "available"
                    ? <span style={{ fontSize:10, padding:"3px 9px", borderRadius:20, background:"#f0fdf4", color:"#16a34a", border:"0.5px solid #bbf7d0", fontWeight:600 }}>● Disponible</span>
                    : <span style={{ fontSize:10, padding:"3px 9px", borderRadius:20, background:"#fff5f5", color:"#dc2626", border:"0.5px solid #fecaca", fontWeight:600 }}>● Loué</span>
                  }
                </div>
              )}
              <div style={{ padding:"16px 18px" }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:4 }}>
                  <div>
                    <div style={{ fontSize:15, fontWeight:800, color:"#0f172a" }}>{car.brand} {car.model}</div>
                    <div style={{ fontSize:12, color:"#64748b", marginTop:2 }}>{car.year} · {car.fuelType} · {car.seats} places</div>
                  </div>
                </div>
                {car.description && (
                  <p style={{ fontSize:12, color:"#64748b", lineHeight:1.5, margin:"8px 0", fontStyle:"italic" }}>{car.description}</p>
                )}
                {car.features?.length > 0 && (
                  <div style={{ display:"flex", gap:5, flexWrap:"wrap", marginBottom:12 }}>
                    {car.features.slice(0,4).map(f => (
                      <span key={f} style={{ fontSize:10, background:"#f8fafc", border:"0.5px solid #e2e8f0", padding:"2px 8px", borderRadius:20, color:"#475569" }}>{f}</span>
                    ))}
                  </div>
                )}
                {car.availability !== "available" && car.nextAvailableDate && (
                  <div style={{ fontSize:11, color:"#d97706", background:"#fffbeb", border:"0.5px solid #fde68a", padding:"6px 10px", borderRadius:7, marginBottom:10 }}>
                    Disponible à partir du {car.nextAvailableDate}
                  </div>
                )}
                <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginTop:12 }}>
                  <div>
                    <div style={{ fontFamily:"'DM Mono',monospace", fontSize:18, fontWeight:700, color:"#1d4ed8" }}>
                      {Number(car.dailyPrice).toLocaleString()}
                    </div>
                    <div style={{ fontSize:10, color:"#94a3b8" }}>MGA / jour</div>
                  </div>
                  <button
                    style={{ padding:"9px 20px", background: car.availability==="available"?"#1d4ed8":"#e2e8f0", color: car.availability==="available"?"white":"#94a3b8", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor: car.availability==="available"?"pointer":"not-allowed", fontFamily:"inherit" }}
                    onClick={() => car.availability==="available" && setRental(car)}
                    disabled={car.availability!=="available"}
                  >
                    {car.availability==="available" ? <><Ico.Key /> Louer</> : "Indisponible"}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      {rental && (
        <RentalModal
          car={rental}
          onClose={() => setRental(null)}
          onSuccess={() => {
            reload();
            setToast({ type:"success", msg:"Location confirmée !" });
            setTimeout(() => setToast(null), 3500);
          }}
        />
      )}
      <Toast t={toast} />
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   PAGE — PROFIL
═══════════════════════════════════════════════════════════ */
const ProfilePage = ({ user }) => {
  const [editing, setEditing] = useState(false);
  const [form,    setForm]    = useState({ name: user?.name||"", email: user?.email||"", phone: user?.phone||"" });
  const [saving,  setSaving]  = useState(false);
  const [toast,   setToast]   = useState(null);

  const initials = (name) => (name||"?").split(" ").map(w=>w[0]).slice(0,2).join("").toUpperCase();

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/dashboard/profile", form);
      setEditing(false);
      setToast({ type:"success", msg:"Profil mis à jour !" });
    } catch {
      setToast({ type:"error", msg:"Erreur lors de la mise à jour." });
    }
    setSaving(false);
    setTimeout(()=>setToast(null), 3500);
  };

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:21, fontWeight:800, color:"#0f172a", letterSpacing:-0.5, marginBottom:4 }}>Mon profil</h1>
        <p style={{ fontSize:12, color:"#94a3b8" }}>Gérez vos informations personnelles</p>
      </div>
      <Card>
        <div style={{ display:"flex", alignItems:"center", gap:20, flexWrap:"wrap" }}>
          <div style={{ width:72, height:72, borderRadius:"50%", background:"#f0fdf4", border:"3px solid #bbf7d0", display:"flex", alignItems:"center", justifyContent:"center", fontSize:22, fontWeight:800, color:"#16a34a", flexShrink:0 }}>
            {initials(user?.name)}
          </div>
          <div>
            <div style={{ fontSize:20, fontWeight:800, color:"#0f172a", letterSpacing:-0.4 }}>{user?.name||"Voyageur"}</div>
            <div style={{ fontSize:13, color:"#94a3b8", marginTop:3 }}>{user?.email||""}</div>
            <div style={{ display:"inline-flex", alignItems:"center", gap:5, marginTop:8, background:"#f0fdf4", color:"#16a34a", border:"0.5px solid #bbf7d0", padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:600 }}>
              ● Compte actif · Voyageur
            </div>
          </div>
          <button
            style={{ marginLeft:"auto", display:"flex", alignItems:"center", gap:6, padding:"8px 16px", background:"none", border:"0.5px solid #e2e8f0", borderRadius:9, fontSize:12, color:"#64748b", cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}
            onClick={() => setEditing(!editing)}
          >
            <Ico.Edit /> {editing?"Annuler":"Modifier"}
          </button>
        </div>
      </Card>
      <Card>
        <CardHead title="Informations personnelles" />
        {editing ? (
          <>
            <Field label={<><Ico.User /> Nom complet</>}>
              <input style={inp} value={form.name} onChange={e=>setForm({...form,name:e.target.value})} />
            </Field>
            <Field label={<><Ico.Mail /> Adresse email</>}>
              <input style={inp} type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} />
            </Field>
            <Field label={<><Ico.Phone /> Téléphone</>}>
              <input style={inp} placeholder="034 00 000 00" value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} />
            </Field>
            <button
              style={{ display:"flex", alignItems:"center", gap:7, padding:"10px 22px", background:"#16a34a", color:"white", border:"none", borderRadius:9, fontSize:13, fontWeight:700, cursor:"pointer", fontFamily:"inherit", opacity:saving?0.7:1 }}
              onClick={save} disabled={saving} className="green-btn"
            >
              {saving ? <><SpinWhite/>Sauvegarde…</> : <><Ico.Check />Sauvegarder</>}
            </button>
          </>
        ) : (
          <div className="form-grid2" style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
            {[
              { label:"Nom complet",   value:user?.name||"—",  icon:<Ico.User />  },
              { label:"Email",         value:user?.email||"—", icon:<Ico.Mail />  },
              { label:"Téléphone",     value:user?.phone||"—", icon:<Ico.Phone /> },
              { label:"Membre depuis", value:"2025",           icon:<Ico.Clock /> },
            ].map(({ label, value, icon }) => (
              <div key={label} style={{ padding:"14px 16px", background:"#f8fafc", borderRadius:10, border:"0.5px solid #f1f5f9" }}>
                <div style={{ display:"flex", alignItems:"center", gap:5, fontSize:10.5, color:"#94a3b8", fontWeight:600, textTransform:"uppercase", letterSpacing:0.5, marginBottom:6 }}>{icon}{label}</div>
                <div style={{ fontSize:14, fontWeight:600, color:"#0f172a" }}>{value}</div>
              </div>
            ))}
          </div>
        )}
      </Card>
      <Card>
        <CardHead title="Sécurité" />
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", padding:"14px 16px", background:"#f8fafc", borderRadius:10, border:"0.5px solid #f1f5f9" }}>
          <div>
            <div style={{ fontSize:13, fontWeight:600, color:"#0f172a" }}>Mot de passe</div>
            <div style={{ fontSize:12, color:"#94a3b8", marginTop:2 }}>Dernière modification il y a 30 jours</div>
          </div>
          <button style={{ fontSize:12, padding:"7px 14px", borderRadius:8, background:"none", border:"0.5px solid #e2e8f0", color:"#64748b", cursor:"pointer", fontFamily:"inherit" }}>Modifier</button>
        </div>
      </Card>
      <Toast t={toast} />
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   PAGE — PAYMENTS
═══════════════════════════════════════════════════════════ */
const PaymentsPage = () => {
  const [payments, setPayments] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/dashboard/payments");
        setPayments(r.data.payments || r.data || []);
      } catch { setPayments([]); }
      setLoading(false);
    })();
  }, []);

  const payVariant = (status) => ({
    SUCCESS:  { bg:"#f0fdf4", color:"#16a34a", border:"#bbf7d0", label:"Payé"       },
    PENDING:  { bg:"#fffbeb", color:"#d97706", border:"#fde68a", label:"En attente" },
    FAILED:   { bg:"#fff5f5", color:"#dc2626", border:"#fecaca", label:"Échoué"     },
  })[(status||"PENDING").toUpperCase()] || { bg:"#f8fafc", color:"#64748b", border:"#e2e8f0", label:status };

  const totalSpent = payments.filter(p=>(p.status||"").toUpperCase()==="SUCCESS").reduce((s,p)=>s+Number(p.amount||0),0);

  return (
    <div>
      <div style={{ marginBottom:20 }}>
        <h1 style={{ fontSize:21, fontWeight:800, color:"#0f172a", letterSpacing:-0.5, marginBottom:4 }}>Paiements</h1>
        <p style={{ fontSize:12, color:"#94a3b8" }}>Historique de toutes vos transactions</p>
      </div>
      <div className="stats-grid" style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:14, marginBottom:18 }}>
        {[
          { label:"Total dépensé",     value:`${totalSpent.toLocaleString()} MGA`, color:"#16a34a", bg:"#f0fdf4" },
          { label:"Paiements réussis", value:payments.filter(p=>(p.status||"").toUpperCase()==="SUCCESS").length, color:"#1d4ed8", bg:"#eff6ff" },
          { label:"En attente",        value:payments.filter(p=>(p.status||"").toUpperCase()==="PENDING").length, color:"#d97706", bg:"#fffbeb" },
        ].map(({ label, value, color, bg }) => (
          <div key={label} style={{ background:"white", border:"0.5px solid #e2e8f0", borderRadius:12, padding:"18px 20px" }}>
            <div style={{ width:32, height:32, borderRadius:8, background:bg, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:12, color }}>
              <Ico.Card />
            </div>
            <div style={{ fontSize:20, fontWeight:800, color:"#0f172a", letterSpacing:-0.5, marginBottom:2 }}>{value}</div>
            <div style={{ fontSize:12, color:"#94a3b8" }}>{label}</div>
          </div>
        ))}
      </div>
      <Card>
        <CardHead title="Historique des transactions" badge={<GrayBadge>{payments.length} transactions</GrayBadge>} />
        {loading ? (
          <div style={{ textAlign:"center", padding:"40px 0", color:"#94a3b8" }}><SpinGreen />Chargement…</div>
        ) : payments.length===0 ? (
          <div style={{ textAlign:"center", padding:"40px 0" }}>
            <div style={{ fontSize:36, marginBottom:10 }}>💳</div>
            <div style={{ fontSize:14, color:"#64748b" }}>Aucune transaction pour l'instant</div>
          </div>
        ) : (
          <div style={{ overflowX:"auto" }}>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead>
                <tr>{["Date","Trajet","Opérateur","Montant","Statut","Référence"].map(h=><Th key={h}>{h}</Th>)}</tr>
              </thead>
              <tbody>
                {payments.map((p,i) => {
                  const v = payVariant(p.status);
                  return (
                    <tr key={p.id??i} className="trow">
                      <Td style={{ color:"#64748b", fontSize:12, fontFamily:"'DM Mono',monospace", whiteSpace:"nowrap" }}>
                        {p.createdAt ? new Date(p.createdAt).toLocaleDateString("fr-FR") : "—"}
                      </Td>
                      <Td>
                        {p.route ? (
                          <div style={{ display:"flex", alignItems:"center", gap:5 }}>
                            <Pill>{p.route.split("→")[0]?.trim()}</Pill>
                            <span style={{ color:"#cbd5e1", fontSize:9 }}><Ico.Arrow /></span>
                            <Pill>{p.route.split("→")[1]?.trim()}</Pill>
                          </div>
                        ) : <span style={{ color:"#94a3b8" }}>—</span>}
                      </Td>
                      <Td style={{ fontSize:12, color:"#475569" }}>{p.operator||"—"}</Td>
                      <Td><span style={{ fontFamily:"'DM Mono',monospace", fontWeight:700, color:"#0f172a" }}>{Number(p.amount||0).toLocaleString()} MGA</span></Td>
                      <Td>
                        <span style={{ fontSize:11, padding:"3px 10px", borderRadius:20, fontWeight:600, background:v.bg, color:v.color, border:`0.5px solid ${v.border}` }}>
                          {v.label}
                        </span>
                      </Td>
                      <Td style={{ fontSize:11, color:"#94a3b8", fontFamily:"'DM Mono',monospace" }}>{p.transactionReference||"—"}</Td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
};

/* ═══════════════════════════════════════════════════════════
   SIDEBAR
═══════════════════════════════════════════════════════════ */
const NAV = [
  { id:"dashboard",  icon:<Ico.Grid />,   label:"Dashboard"         },
  { id:"tickets",    icon:<Ico.Ticket />, label:"Mes billets"       },
  { id:"routes",     icon:<Ico.Route />,  label:"Mes trajets"       },
  { id:"carpooling", icon:<Ico.Car />,    label:"Covoiturage"       },
  { id:"rentals",    icon:<Ico.Key />,    label:"Location voiture"  },
  { id:"profile",    icon:<Ico.User />,   label:"Mon profil"        },
  { id:"payments",   icon:<Ico.Card />,   label:"Paiements"         },
];

const Sidebar = ({ active, setTab, logout, user, close }) => {
  const initials = (name) => (name||"?").split(" ").map(w=>w[0]).slice(0,2).join("").toUpperCase();
  return (
    <div style={{ display:"flex", flexDirection:"column", height:"100%", padding:"0 0 24px" }}>
      <div style={{ display:"flex", alignItems:"center", gap:8, padding:"20px 18px 16px", borderBottom:"0.5px solid #e2e8f0" }}>
        <Link to="/" style={{ fontSize:17, fontWeight:800, color:"#0f172a", textDecoration:"none", letterSpacing:-0.5 }}>
          Trans<span style={{ color:"#16a34a" }}>TiGo</span>
        </Link>
        <span style={{ fontSize:8, fontWeight:700, background:"#f0fdf4", color:"#16a34a", padding:"2px 7px", borderRadius:20, textTransform:"uppercase", letterSpacing:0.8, border:"0.5px solid #bbf7d0" }}>Voyageur</span>
      </div>
      <div style={{ display:"flex", alignItems:"center", gap:10, padding:"12px 14px", margin:"8px 10px 4px", background:"#f8fafc", borderRadius:10, border:"0.5px solid #f1f5f9" }}>
        <div style={{ width:34, height:34, borderRadius:"50%", background:"#f0fdf4", color:"#16a34a", border:"1px solid #bbf7d0", display:"flex", alignItems:"center", justifyContent:"center", fontSize:11, fontWeight:700, flexShrink:0 }}>
          {initials(user?.name)}
        </div>
        <div style={{ minWidth:0 }}>
          <div style={{ fontSize:13, fontWeight:700, color:"#0f172a", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{user?.name||"Voyageur"}</div>
          <div style={{ fontSize:10, color:"#94a3b8", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{user?.email||""}</div>
        </div>
      </div>
      <nav style={{ display:"flex", flexDirection:"column", gap:1, padding:"8px 0", flex:1 }}>
        {NAV.map(({ id, icon, label }) => {
          const isActive = active===id;
          return (
            <button key={id} onClick={() => { setTab(id); close?.(); }} className="nav-btn"
              style={{ display:"flex", alignItems:"center", gap:9, padding:"9px 16px", fontSize:13, color:isActive?"#16a34a":"#64748b", background:isActive?"#f0fdf4":"none", border:"none", cursor:"pointer", fontFamily:"inherit", width:"100%", textAlign:"left", position:"relative", fontWeight:isActive?700:400 }}>
              <span style={{ width:15, height:15, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, color:isActive?"#16a34a":"#94a3b8" }}>{icon}</span>
              {label}
              {isActive && <div style={{ position:"absolute", left:0, top:0, bottom:0, width:2, background:"#16a34a", borderRadius:"0 2px 2px 0" }} />}
            </button>
          );
        })}
      </nav>
      <div style={{ padding:"0 10px", marginTop:"auto" }}>
        <button style={{ display:"flex", alignItems:"center", gap:8, padding:"9px 14px", fontSize:13, color:"#94a3b8", background:"none", border:"none", cursor:"pointer", fontFamily:"inherit", width:"100%", borderRadius:8 }} onClick={logout} className="logout-btn">
          <Ico.Logout /> Déconnexion
        </button>
      </div>
    </div>
  );
};

const BottomNav = ({ active, setTab, logout }) => (
  <div style={{
    display: "none", position: "fixed", bottom: 0, left: 0, right: 0,
    background: "white", borderTop: "0.5px solid #e2e8f0", zIndex: 300,
    padding: "6px 0 env(safe-area-inset-bottom, 8px)",
  }} className="bottom-nav">
    {NAV.map(({ id, icon, label }) => {
      const isActive = active === id;
      return (
        <button key={id} onClick={() => setTab(id)} style={{
          flex: 1, display: "flex", flexDirection: "column", alignItems: "center",
          gap: 3, padding: "6px 2px", background: "none", border: "none",
          cursor: "pointer", fontFamily: "inherit",
          color: isActive ? "#16a34a" : "#94a3b8", minWidth: 0,
        }}>
          <span style={{ display: "flex", alignItems: "center", justifyContent: "center",
            width: 28, height: 28, borderRadius: 8,
            background: isActive ? "#f0fdf4" : "none",
            color: isActive ? "#16a34a" : "#94a3b8", transition: "all 0.15s",
          }}>{icon}</span>
          <span style={{ fontSize: 9, fontWeight: isActive ? 700 : 500,
            letterSpacing: 0.2, overflow: "hidden", textOverflow: "ellipsis",
            whiteSpace: "nowrap", maxWidth: "100%",
          }}>{label}</span>
        </button>
      );
    })}
    <button onClick={logout} style={{
      flex: 1, display: "flex", flexDirection: "column", alignItems: "center",
      gap: 3, padding: "6px 2px", background: "none", border: "none",
      cursor: "pointer", fontFamily: "inherit", color: "#94a3b8", minWidth: 0,
    }}>
      <span style={{ display: "flex", alignItems: "center", justifyContent: "center",
        width: 28, height: 28, borderRadius: 8, background: "none",
        color: "#f87171", transition: "all 0.15s",
      }}><Ico.Logout /></span>
      <span style={{ fontSize: 9, fontWeight: 500, letterSpacing: 0.2, color: "#f87171" }}>Quitter</span>
    </button>
  </div>
);

/* ═══════════════════════════════════════════════════════════
   MAIN EXPORT
═══════════════════════════════════════════════════════════ */
const Dashboard = () => {
  const { user, logout } = useAuth();
  const [tab,    setTab]    = useState("dashboard");
  const [cities, setCities] = useState([]);
  const [stats,  setStats]  = useState({ tickets:0, trips:0, payments:0 });
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/cities").then(r=>setCities(r.data)).catch(()=>{});
    api.get("/dashboard/stats").then(r=>setStats(r.data)).catch(()=>{});
    api.get("/dashboard/recent-bookings").then(r=>setRecent(r.data)).catch(()=>{});
  }, []);

  const pageTitle = {
    dashboard:"Dashboard", tickets:"Mes billets", routes:"Mes trajets",
    carpooling:"Covoiturage", rentals:"Location voiture",
    profile:"Mon profil", payments:"Paiements",
  };

  const renderPage = () => {
    switch(tab) {
      case "tickets":    return <TicketsPage />;
      case "routes":     return <RoutesPage cities={cities} />;
      case "carpooling": return <CarpoolingPage cities={cities} user={user} />;
      case "rentals":    return <RentalsPage />;
      case "profile":    return <ProfilePage user={user} />;
      case "payments":   return <PaymentsPage />;
      default:           return <DashboardHome user={user} stats={stats} recentBookings={recent} cities={cities} goTo={setTab} />;
    }
  };

  return (
    <div style={{ display:"flex", background:"#f8fafc", minHeight:"100vh", fontFamily:"'Plus Jakarta Sans',sans-serif" }}>
      <style>{CSS}</style>
      <div className="mobile-bar" style={{ display:"none", alignItems:"center", justifyContent:"space-between", padding:"0 16px", height:50, background:"white", borderBottom:"0.5px solid #e2e8f0", position:"fixed", top:0, left:0, right:0, zIndex:100 }}>
        <Link to="/" style={{ fontSize:15, fontWeight:800, color:"#0f172a", textDecoration:"none" }}>
          Trans<span style={{ color:"#16a34a" }}>TiGo</span>
        </Link>
        <span style={{ fontSize:13, fontWeight:600, color:"#64748b" }}>{pageTitle[tab]}</span>
        <div style={{ width:32 }} />
      </div>
      <div className="sidebar" style={{ width:234, background:"white", borderRight:"0.5px solid #e2e8f0", flexShrink:0, position:"sticky", top:0, height:"100vh", overflow:"auto" }}>
        <Sidebar active={tab} setTab={setTab} logout={logout} user={user} close={() => {}} />
      </div>
      <div style={{ flex:1, overflowX:"hidden" }} className="main-area">
        <div style={{ padding:28 }}>
          {renderPage()}
        </div>
      </div>
      <BottomNav active={tab} setTab={setTab} logout={logout} />
    </div>
  );
};

export default Dashboard;

/* ═══════════════════════════════════════════════════════════
   CSS
═══════════════════════════════════════════════════════════ */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=DM+Mono:wght@400;500&display=swap');
  @keyframes spin { to { transform: rotate(360deg); } }
  * { box-sizing: border-box; }

  .nav-btn:hover:not([style*="background:#f0fdf4"]) { color:#0f172a !important; background:#f8fafc !important; }
  .logout-btn:hover { color:#dc2626 !important; }
  .trow:hover td { background:#fafafa !important; }
  .cp-card:hover { box-shadow:0 4px 16px rgba(0,0,0,.06) !important; }
  .car-card:hover { box-shadow:0 4px 16px rgba(0,0,0,.08) !important; transform:translateY(-1px); transition:all .15s; }
  .green-btn:hover:not(:disabled) { background:#166534 !important; }
  .dark-btn:hover:not(:disabled)  { background:#1e293b !important; }
  .teaser:hover { box-shadow:0 2px 12px rgba(22,163,74,0.1) !important; transform:translateY(-1px); transition:all .15s; }
  .trip-row-card:hover { background:#fafafa !important; border-color:#cbd5e1 !important; }

  select:focus, input:focus, textarea:focus {
    border-color:#16a34a !important;
    box-shadow:0 0 0 3px rgba(22,163,74,0.08) !important;
    outline:none;
  }
  input[type="date"]::-webkit-calendar-picker-indicator,
  input[type="time"]::-webkit-calendar-picker-indicator { cursor:pointer; opacity:.6; }

  @media (max-width: 992px) {
    .mobile-bar   { display: flex !important; }
    .sidebar      { display: none !important; }
    .bottom-nav   { display: flex !important; }
    .main-area    { padding: 0 !important; }
    .main-area > div { padding: 16px !important; padding-top: 66px !important; padding-bottom: 80px !important; }
    .stats-grid   { grid-template-columns: 1fr 1fr !important; }
    .search-grid  { grid-template-columns: 1fr !important; }
    .cp-grid      { grid-template-columns: 1fr !important; }
    .coop-grid    { grid-template-columns: 1fr !important; }
    .form-grid2   { grid-template-columns: 1fr !important; }
    .teasers-grid { grid-template-columns: 1fr 1fr !important; }
    .car-grid     { grid-template-columns: 1fr 1fr !important; }
  }
  @media (max-width: 640px) {
    .stats-grid   { grid-template-columns: 1fr !important; }
    .car-grid     { grid-template-columns: 1fr !important; }
    .teasers-grid { grid-template-columns: 1fr !important; }
    .main-area > div { padding: 12px !important; padding-top: 62px !important; padding-bottom: 80px !important; }
  }
`;